import { Injectable } from '@angular/core';

import XYZ from 'ol/source/XYZ';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import {createXYZ} from 'ol/tilegrid';
import styleFunction from 'ol-mapbox-style/dist/stylefunction';

import Feature from 'ol/Feature';
import Group from 'ol/layer/Group';
import Heatmap from 'ol/layer/Heatmap';
import * as proj from 'ol/proj';
import { register } from 'ol/proj/proj4';
import * as condition from 'ol/events/condition';
import OSM from 'ol/source/OSM';
import Control from 'ol/control/Control';
import GeoJSON from 'ol/format/GeoJSON';
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import TileGrid from 'ol/tilegrid/TileGrid';
import TileImage from 'ol/source/TileImage';
import TileWMS from 'ol/source/TileWMS';
import Modify from 'ol/interaction/Modify';
import Select from 'ol/interaction/Select';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import FullScreen from 'ol/control/FullScreen';
import Icon from 'ol/style/Icon';
import Draw from 'ol/interaction/Draw';
import * as olColor from 'ol/color';
import { getDistance } from 'ol/sphere';
import * as olExtent from 'ol/extent';
import * as olControl from 'ol/control';
// import * as olInteraction from 'ol/interaction';
import Map from 'ol/Map';
import LineString from 'ol/geom/LineString';
import MultiLineString from 'ol/geom/MultiLineString';
import MultiPoint from 'ol/geom/MultiPoint';
import MultiPolygon from 'ol/geom/MultiPolygon';
import Point from 'ol/geom/Point';
import Polygon from 'ol/geom/Polygon';
import { circular } from 'ol/geom/Polygon';
import Snap from 'ol/interaction/Snap';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import Text from 'ol/style/Text';
import LayerVector from 'ol/layer/Vector';
import SourceVector from 'ol/source/Vector';
import Zoom from 'ol/control/Zoom';
import proj4 from 'proj4';
import {SclUtilMapService} from './scl-util-map.service';
import {SclProjectionConstantService} from './scl-projection-constant.service';
import {SclMapViewsService} from './scl-map-views.service';
import {SclMapConstantService} from './scl-map-constant.service';
import {SclAssetLayersService} from './scl-asset-layers.service';
import Cluster from 'ol/source/Cluster';
import { defaults } from 'ol/interaction';
import {isNumber} from 'lodash';
import {boundingExtent} from 'ol/extent';

const sclUtilMap = new SclUtilMapService();
const sclProjectionConstant = SclProjectionConstantService;
const sclMapViews = new SclMapViewsService();
const sclMapConstant = SclMapConstantService;
const sclAssetLayers = new SclAssetLayersService();
/** inherits has been removed in OpenLayers 6, according to
 * https://github.com/openlayers/openlayers/blob/master/changelog/upgrade-notes.md#removal-of-deprecated-methods
 * This function replaces it
 */
function olInherits(child, parent) {
  child.prototype = Object.create(parent.prototype);
  child.prototype.constructor = child;
}

@Injectable({
  providedIn: 'root'
})
export class SclMappingFunctionOpenLayersService {

  constructor() {
    console.log('************ OL using dynamic style');
  }

  sclUtilMapService = new SclUtilMapService();
  source; // source vector
  view; // view
  vector; // vector
  map; // map
  proj4s = proj4;
  actionType = '';
  draw;
  select; modify;  selectMultiple;
  divWrapper;
  EPSG;
  tileLayers;
  selectionStyle;
  setDirtyFunction;
  selectedAssets = [];
  openSansAdded = false;
  wmsState = { hasTile: false, hasEvent: false, finishLoad: false, tileCount: 0, hasTransparency: false, waitMapRender: null };
  type = -1; // 0 : boundary, 1 : address, 2: street-address, 3: selected-asset
  layerAssets = [];
  layerIndexFilter = -1; layerIndexUser = -1; layerIndexAddress = -1;
  layerIndexPrimary = -1; layerIndexSecondary = -1; layerIndexTooltips = -1; layerIndexControl = -1;
  // this.stlBoundary;//styleBoundary
  fitObject = { hasCall : false , service : null, maxZoom : null, initialZoomChange: null };
  positionObject = { hasCall: false, lat: null, lon: null, zoom: null, epsg: null };
  setupMapDone;
  canvas;
  primaryAssetSelection; secondaryAssetSelection;
  drawingMode = 'single'; // for sc-boundary
  modeLabel; // for sc-boundary
  color = 'black'; multiColor = 'red' ; // for sc-boundary
  layersRedraw = false; layersRedrawCount = 0; assetOfLayers = {}; // <layerIndex, [assets]>;//for sc-selected-asset test re-draw
  heightNum = 1; mapId;
  // heat map
  lstHeatWeight = []; heatDatas = [];
  defaultZoom; defaultLat; defaultLon;
  zoomFloor = 12; // 14254
  compActionType = ''; // 14310: '' = no action, 'primary', 'secondary', ....
  isMapReady = false;
  // call this function for draw on map
  controlBtns = []; elementCtrl;
  testDiv;

  bounds; onTilesLoaded; addressImageAnchor; primaryImageAnchor; secondaryImageAnchor; snap; drawType; marker; fitCoordCount;
  psmaReverse; checkMapLoadDone; show;
  getLocationFn; // sc-boundary : 14786#c56443

  fromFitData = false; // 14930
  afterLoadSelectedAssetFn; // 15145
  selectPointerMove; toolTipOnFeatureHover; // 15141#c57727
  setupTooltipUI;
  mapDiv;
  fullScreenEvent; // 15336#c59379
  clusterClick; // 15251#c59696
  heightMapInit = 0; // 15755
  hasClickButtonZoom = false; // 15860
  onMapWheelScroll = null; // 15973
  fitPadding = 0; countGetImgSrc = 0;

  load(cb) {
    if (cb && typeof cb === 'function') {
      cb();
    }
  }

  interactionSelect() {
    this.select = new Select();
  }

  interactionModify() {
    this.modify = new Modify({
      features: this.select.getFeatures()
    });
    this.modify.on('modifyend', (e) => {
      if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
        // scope.$apply();
      }
    });
  }

  interactionSelectMultiple(isActive, cb) {
    this.selectMultiple = new Select({
      multi: true,
      condition: condition.click,
      toggleCondition: condition.primaryAction,
      style: this.styleSelectedFunc.bind(this)
    });
    this.selectMultiple.setActive(isActive);
    const self = (this as any);
    this.selectMultiple.on('select',
      function(e) {
      // add feature to layer user
      const selected = e.target.getFeatures();
      for (let i = 0; i < selected.getLength(); i++) {
        const fea = selected.getArray()[i];
        if (fea === 'undefined' || fea == null) { continue; }
        const pro = fea.getProperties();
        if (pro == null) { continue; }

        if (!pro.layerDisplayOnly) {
          self.addFeature(fea, self.layerIndexUser);
        }
      }

      if (cb && typeof cb === 'function') {
        cb(e);
      }
    });
  }

  checkGeoJson(geojson) {
    if (typeof geojson.features === 'undefined' || geojson.features.length == null || geojson.features.length === 0) { return false; }
    const f0 = geojson.features[0];
    if ( typeof f0.type !== 'undefined' && typeof f0.geometry !== 'undefined'
      && typeof f0.geometry.type !== 'undefined') { return true; }

    return false;
  }

  clampZoomFloor() {
    // console.log('%c clampZoomFloor, currentZoom = ' + this.view.getZoom() + ', zoomFloor = ' + this.zoomFloor, 'color:blue');
    if (this.view.getZoom() > this.zoomFloor) { this.view.setZoom(this.zoomFloor); }
  }

  getTile(mapView, isShow) {
    let tile;
    this.wmsState = { hasTile: false, hasEvent: false, finishLoad: false, tileCount: 0, hasTransparency: false, waitMapRender: null };
    const self = this;
    let tileLoading = 0; let tileLoaded = 0;
    if (mapView.serverType === 'tile') {
      const tileSource = new OSM({
        url: mapView.url,
        crossOrigin: mapView.crossOrigin,
        wrapDateLine: false,
        wrapX: false,
        noWrap: true
      });
      tile = new TileLayer({
        title: mapView.uiLabel,
        visible: isShow,
        source: tileSource
      });
      this.wmsState.hasTile = true;
      tileSource.on('tileloadstart', function(event) {
        // do some stuff start loading tiles...
        self.wmsState.hasEvent = true;
        // console.log("%c tileSource.tileloadstart", 'color:blue');
        tileLoading++;
      });
      tileSource.on('tileloadend', function(event) {
        // do some stuff tiles were loaded...
        // console.log("%c tileSource.tileloadend", 'color:blue');
        tileLoaded++;
        if (tileLoaded === tileLoading) {
          // do stuff
          // console.log("%c FINISH LOAD TILE", 'color:blue');
          self.wmsState.tileCount = tileLoaded;
          self.wmsState.finishLoad = true;
          if (this.fromFitData) {
            this.checkMapEmpty(this.canvas);
          }
          if (self.afterLoadSelectedAssetFn && typeof self.afterLoadSelectedAssetFn === 'function') {
            self.afterLoadSelectedAssetFn();
          }
        }
      });
      tileSource.on('tileloaderror', function(event) {
        // Changed Notification to logger message as errors are not helpful in most cases
        console.log('tileloaderror, There has been an error returned from the mapping service tileloader - is the map visible?');
      });
    } else {
      let tileGrid;
      if (mapView.extent) {
        tileGrid = new TileGrid({
          extent: mapView.extent,
          resolutions: mapView.resolutions,
          tileSize: mapView.tileSize
        });
      }
      const tileWMS = new TileWMS({
        url: mapView.url,
        params: mapView.params,
        projection: mapView.EPSG,
        serverType: mapView.serverType,
        tileGrid,
        wrapDateLine: false,
        wrapX: false,
        noWrap: true,
        crossOrigin: 'anomymous'
      });

      this.wmsState.hasTile = true;

      tileWMS.on('tileloadstart', function(event) {
        // do some stuff start loading tiles...
        self.wmsState.hasEvent = true;
        // console.log("%c tileWMS.tileloadstart, tile_loading = " + tile_loading + ", tile_loaded = " + tile_loaded, 'color:blue');
        tileLoading++;
      });

      tileWMS.on('tileloadend', function(event) {
        // do some stuff tiles were loaded...
        // console.log("%c tileWMS.tileloadend", 'color:blue');
        tileLoaded++;
        if (tileLoaded === tileLoading) {
          // do stuff
          // console.log('%c FINISH LOAD TILE WMS, tile_loading = ' + tileLoading + ', tile_loaded = ' + tileLoaded, 'color:blue');
          self.wmsState.tileCount = tileLoaded;
          self.wmsState.finishLoad = true;
          if (this.fromFitData) {
            this.checkMapEmpty(this.canvas);
          }
          if (self.afterLoadSelectedAssetFn && typeof self.afterLoadSelectedAssetFn === 'function') {
            self.afterLoadSelectedAssetFn();
          }
        }
      });
      tileWMS.on('tileloaderror', function(event) {
        // Changed Notification to logger message as errors are not helpful in most cases
        console.log('There has been an error returned from the mapping service tileloader - is the map visible?');
        // console.log("%c tileWMS.tileloaderror", 'color:blue');
      });

      tile = new TileLayer({
        title: mapView.uiLabel,
        visible: isShow,
        source: tileWMS,
        crossOrigin: 'anomymous'
      });
      if (mapView.extent) {
        tile.setExtent(mapView.extent);
      }
    }

    return tile;
  }

  multiLayers(mapViews) {
    const layers = [];
    if (typeof mapViews !== 'undefined' && mapViews !== null) {

      let existShow = false;
      for (let i = 0; i < mapViews.length; i++) {
        const mapView = mapViews[i];
        if (mapView.isShow) {
          existShow = true;
          break;
        }
      }
      for (let i = 0; i < mapViews.length; i++) {
        const mapView = mapViews[i];


        if (typeof mapView.EPSG !== 'undefined' && mapView.EPSG !== null) {
          proj4.defs(mapView.EPSG, sclProjectionConstant.EPSG[mapView.EPSG]);
        }

        let isVisible = true;
        if (mapView.visible != null) { isVisible = mapView.visible; }
        if (isVisible === false) { continue; }// go to next element

        let isShow = false;
        if (mapView.isShow) { isShow = mapView.isShow; }
        if (!existShow && i === 0) {
          existShow = true;
          isShow = true;
        }
        let tile = null;
        if (mapView.groupView) {
          const listLayers = [];
          for (let j = 0; j < mapView.groupView.length; j++) {
            const view = mapView.groupView[j];
            const member = this.getTile(view, isShow);
            listLayers.push(member);
          }
          tile = new Group({
            visible: isShow,
            title: mapView.uiLabel,
            layers: listLayers
          });
        } else {
          tile = this.getTile(mapView, isShow);
        }

        layers.push(tile);
      }

    }
    return layers;
  }

  setView(lng, lat, zoom, EPSG, minResolution, maxResolution, maxZoom) {
    lat = typeof lat !== 'undefined' ? lat : 0;
    lng = typeof lng !== 'undefined' ? lng : 0;
    zoom = typeof zoom !== 'undefined' ? zoom : 2;
    EPSG = typeof EPSG !== 'undefined' ? EPSG : 'EPSG:3857';
    maxZoom = typeof maxZoom !== 'undefined' ? maxZoom : 19; // 13924-2
    let view;
    if (EPSG !== sclMapConstant.EPSG_3857) {
      const projection = sclProjectionConstant.EPSG;
      proj4.defs(EPSG, projection[EPSG]);
    }

    // the following gave an error that proj4 wasn't found in ol.proj. The register function
    // can be imported directly, as in
    // https://openlayers.org/en/latest/apidoc/module-ol_proj_proj4.html
    // if (proj.proj4 && proj.proj4.register) { proj.proj4.register(proj4); }
    register(proj4);

    if (minResolution && maxResolution) {
      view = new View({
        projection: EPSG,
        center: proj.transform([lng, lat], 'EPSG:4326', EPSG),
        zoom,
        // maxZoom: 12,//13885
        maxZoom,
        minResolution,
        maxResolution
      });
    } else {
      view = new View({
        projection: EPSG,
        center: proj.transform([lng, lat], 'EPSG:4326', EPSG),
        zoom,
        // maxZoom: 12,//13885
        maxZoom,
        minZoom: 2
      });
    }
    return view;
  }

  createLayerSourceNormal(zIndex, pStyle, title, source, layerDisplayOnly) {
    return new LayerVector({ title, source, zIndex, style: pStyle, isHeatMap: false, layerDisplayOnly });
  }

  createLayerCluster(zIndex, pStyle, title, source, layerDisplayOnly, distance) {
    let d = 20; // default distance
    if (distance) { d = distance; }
    const clusterSource = new Cluster({
      distance: d,
      source: source
    });
    const clusterLayer = new LayerVector({
      name: 'Cluster',
      source: clusterSource,
      // Cluster style
      style: pStyle,
      zIndex,
      isHeatMap: false,
      layerDisplayOnly,
      isCluster: true
    });
    return clusterLayer;
  }

  createEmptyLayer(zIndex, pStyle, title, isHeatMap, options) {
    let newLayer;
    let src = new SourceVector();
    let layerDisplayOnly = false;
    if (options && options.layerDisplayOnly) { layerDisplayOnly = options.layerDisplayOnly; }
    if (isHeatMap) {
      let gradient = ['#00f', '#0ff', '#0f0', '#ff0', '#f00']; // default from ol
      if (options != null && typeof options.gradient !== 'undefined') { gradient = options.gradient; }
      let opacity = 1;
      if (options != null && typeof options.opacity !== 'undefined') { opacity = options.opacity; }
      let radius = 8; // default from ol
      if (options != null && typeof options.radius !== 'undefined') { radius = options.radius; }
      let blur = 15; // default from ol
      if (options != null && typeof options.blur !== 'undefined') { blur = options.blur; }
      let shadow = 250; // default from ol
      if (options != null && typeof options.shadow !== 'undefined') { shadow = options.shadow; }
      newLayer = new Heatmap({
        source: src,
        zIndex,
        gradient,
        opacity,
        radius,
        blur,
        shadow,
        renderMode: 'image',
        title,
        isHeatMap,
        layerDisplayOnly
      }); // renderMode = image for better performance

    } else {
      if (options && options.type === 'cluster') {
        newLayer = this.createLayerCluster(zIndex, pStyle, title, src, layerDisplayOnly, options.clusterDistance);
      } else {
        newLayer = this.createLayerSourceNormal(zIndex, pStyle, title, src, layerDisplayOnly);
      }
      
    }
    // newLayer.set('isHeatMap', isHeatMap);
    return newLayer;
  }

  createLayerAsset(layerQuery, styleLayer, hasFilterQuery, styleFilter, hasSecondary, styleSecondary,
                   hasPrimary, stylePrimary, hasUserItems, styleSelected, hasAddressPoint, stylePoint) {
    // 1) UI controls (zoom, map selector. etc)
    // 2) Tooltips, other popup controls
    // 3) User added items : address pins, selections, etc
    // 4) Objects returned from "primaryAssetFilter"
    // 5) Objects returned from "secondaryAssetFilter"
    // 6) Objects returned from a "filter" query at the root of the component
    // 7) Items returned from the layers[0] entry
    // 8) items returned from layers[1] entry
    // 9) Items returned from layers[n] entry, where n is the last layer in the array
    // 10) Base map images
    let layerIndex = 0;
    if (this.layerAssets == null) { this.layerAssets = []; }
    if (layerQuery) {// 9,8,7
      for (let i = 0; i < layerQuery.length; i++) {
        if (layerQuery[i].query.indexOf('_layer') < 0) {
          continue;
        }
        layerIndex++;
        if (layerQuery[i].layer.type === 'cluster') {
          this.layerAssets.push(this.createEmptyLayer(layerIndex, styleLayer, 'layer' + layerIndex, layerQuery[i].isHeatMap,
          layerQuery[i].layer));
        } else {
          this.layerAssets.push(this.createEmptyLayer(layerIndex, null, 'layer' + layerIndex, layerQuery[i].isHeatMap,
          layerQuery[i].layer));
        }
      }
    }
    if (hasFilterQuery) {// 6
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, styleLayer, 'filter', null, null));
      this.layerIndexFilter = layerIndex;
    }
    if (hasSecondary) {// 5
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, styleSecondary, 'secondary', null, null));
      this.layerIndexSecondary = layerIndex;
    }
    if (hasPrimary) {// 4
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, stylePrimary, 'primary', null, null));
      this.layerIndexPrimary = layerIndex;
    }

    if (hasUserItems) {// 3
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, styleSelected, 'selectedItems', null, null));
      this.layerIndexUser = layerIndex;
    }
    if (hasAddressPoint) {// 3
      layerIndex++;
      this.layerAssets.push(this.createEmptyLayer(layerIndex, stylePoint, 'addressPoint', null, null));
      this.layerIndexAddress = layerIndex;
    }
    // tooltips
    this.layerIndexTooltips = layerIndex + 1;
    // controls button
    this.layerIndexControl = layerIndex + 2;
  }

  createLayers(initObj) {
    this.layerAssets = [];
    this.layerAssets.push(this.vector);

    if (this.type === 0) {// sc-boundary
      this.createLayerAsset([], this.styleBoundary.bind(this), false, null, false,
        null, false, null, false, null, true, this.styleBoundary.bind(this));
    } else if (this.type === 1) {// sc-address-map
      // if (initObj.layerAssets) {
      //   this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, this.styleAddress.bind(this),
      //     false, null, false, null, true, this.styleSelectedFunc.bind(this), false, null);
      // } else { this.createLayerAsset([], this.styleAddress.bind(this), true, this.styleAddress.bind(this),
      //   false, null, false, null, true, this.styleSelectedFunc.bind(this), false, null); }
      if (initObj.layerAssets) {
        this.createLayerAsset(initObj.layerAssets, this.styleAddress.bind(this), true, null,
          false, null, false, null, true, null, false, null);
      } else { this.createLayerAsset([], null, true, null,
        false, null, false, null, true, null, false, null); }
    } else if (this.type === 2) {// sc-street-address
      this.createLayerAsset([], null, false, null, false, null, false, null, false, null, true, this.styleStAddress.bind(this));
    } else if (this.type === 3) {// sc-selected-asset
      // if (initObj.layerAssets) {
      //   this.createLayerAsset(initObj.layerAssets, this.styleAsset.bind(this), true, this.styleAsset.bind(this),
      //     true, this.styleSecondaryAssetFunc.bind(this), true, this.stylePrimaryAssetFunc.bind(this),
      //     false, null, true, this.styleAsset.bind(this));
      // } else { this.createLayerAsset([], this.styleAsset.bind(this), true, this.styleAsset.bind(this),
      //   true, this.styleSecondaryAssetFunc.bind(this), true, this.stylePrimaryAssetFunc.bind(this),
      //   false, null, true, this.styleAsset.bind(this)); }
      if (initObj.layerAssets) {
        this.createLayerAsset(initObj.layerAssets, null, true, null,
          true, null, true, null,
          false, null, true, null); // 15886: high CPU
      } else { this.createLayerAsset([], null, true, null,
        true, null, true, null,
        false, null, true, null); } // 15886: high CPU
    }

  }

  createHeatMap(layerIndex) {

    this.layerAssets[layerIndex].getSource().clear(); // reset

    const min = Math.min.apply(null, this.lstHeatWeight);
    const max = Math.max.apply(null, this.lstHeatWeight);

    for (let i = 0; i < this.heatDatas.length; i++) {
      let weight = (this.heatDatas[i].weight - min) / (max - min); // clamp weight 0..1

      if (isNaN(weight)) {
        if (max === min) { weight = 1; } else {  weight = 0; }
      }
      if (weight > 1) { weight = 1; }
      // created for owl range of data
      const coord = proj.transform(this.heatDatas[i].location, 'EPSG:4326', this.EPSG) ;

      const lonLat = new Point(coord);

      const pf = new Feature({
        geometry: lonLat,
        weight // e.g. temperature
      });

      this.layerAssets[layerIndex].getSource().addFeature(pf);
    }

    this.heatDatas = []; // reset
    this.lstHeatWeight = []; // reset
  }

  init(initObj) {
    this.EPSG = initObj.EPSG;
    if (this.EPSG === sclMapConstant.EPSG_4326) { this.EPSG = 'EPSG:3857'; }
    if (this.EPSG !== sclMapConstant.EPSG_4326) {
      const projection = sclProjectionConstant.EPSG;
      this.proj4s.defs(this.EPSG, projection[this.EPSG]);
    }
    this.divWrapper = initObj.divWrapper;
    this.selectedAssets = [];

    if (initObj.setDirty) { this.setDirtyFunction = initObj.setDirty; }

    this.type = initObj.style;
    let coordinates;
    if (initObj.formatGeoJSON) {// use for sc-boundary
      coordinates = initObj.formatGeoJSON;
      if (initObj.formatGeoJSON.crs) {
        this.EPSG = initObj.formatGeoJSON.crs.properties.name;
      }
    }
    if (initObj.setupMapDone) { this.setupMapDone = initObj.setupMapDone; }


    // 13835
    this.source = new SourceVector();

    if (initObj.selectionStyle) { this.selectionStyle = initObj.selectionStyle; }
    if (initObj.primaryAssetSelection) { this.primaryAssetSelection = initObj.primaryAssetSelection; }
    if (initObj.secondaryAssetSelection) { this.secondaryAssetSelection = initObj.secondaryAssetSelection; }
    if (initObj.color) { this.color = initObj.color; }
    if (initObj.multiColor) { this.multiColor = initObj.multiColor; }
    if (initObj.layersRedraw) { this.layersRedraw = initObj.layersRedraw; }
    if (initObj.heightNum) { this.heightNum = initObj.heightNum; }
    if (initObj.mapId) { this.mapId = initObj.mapId; }
    if (initObj.onTilesLoaded) { this.onTilesLoaded = initObj.onTilesLoaded; }
    if (initObj.zoomFloor) { this.zoomFloor = initObj.zoomFloor; }
    if (initObj.getLocationFn) { this.getLocationFn = initObj.getLocationFn; }
    if (initObj.setupTooltipUI) { this.setupTooltipUI = initObj.setupTooltipUI; }
    if (initObj.target) { 
      this.mapDiv = initObj.target; 
      this.heightMapInit = initObj.target.offsetHeight;
    }
    if (initObj.fullScreenEvent) { this.fullScreenEvent = initObj.fullScreenEvent; }
    if (initObj.clusterClick) { this.clusterClick = initObj.clusterClick; }
    if (initObj.onMapWheelScroll) { this.onMapWheelScroll = initObj.onMapWheelScroll; }

    this.defaultLat = (initObj.defaultLat ? initObj.defaultLat : -37.8);
    this.defaultLon = (initObj.defaultLon ? initObj.defaultLon : 144.9);
    this.defaultZoom = (initObj.defaultZoom ? initObj.defaultZoom : 10);


    if (initObj.style === 0) {
      this.vector = this.createLayerSourceNormal(0, this.styleBoundary.bind(this), 'layerTile', this.source, false);
      if (initObj.layers) {
        this.tileLayers = initObj.layers;
      }

      if (coordinates && this.checkGeoJson(coordinates)) {
        const featuresJSON = (new GeoJSON())
          .readFeatures(coordinates,
            {featureProjection: this.EPSG, dataProjection: 'EPSG:4326'});
        this.vector.getSource().addFeatures(featuresJSON);

      }

    } else if (initObj.style === 1) {
      this.vector = this.createLayerSourceNormal(0, this.styleAddress.bind(this), 'layerTile', this.source, false);

      if (initObj.layers) {
        this.tileLayers = initObj.layers;
      }
    } else if (initObj.style === 2) {
      this.vector = this.createLayerSourceNormal(0, this.styleStAddress.bind(this), 'layerTile', this.source, false);
      if (initObj.layers) {
        this.tileLayers = initObj.layers;
      }
      if (coordinates && this.checkGeoJson(coordinates)) {
        this.vector.getSource().addFeatures({
          features: (new GeoJSON()).readFeatures(coordinates)
        });
      }
    } else if (initObj.style === 3) {
      this.addressImageAnchor = initObj.addressImageAnchor;
      this.primaryImageAnchor = initObj.primaryImageAnchor;
      this.secondaryImageAnchor = initObj.secondaryImageAnchor;
      this.vector = this.createLayerSourceNormal(0, this.styleAsset.bind(this), 'layerTile', this.source, false);
      if (initObj.layers) {
        this.tileLayers = initObj.layers;
      }
      if (coordinates && this.checkGeoJson(coordinates)) {
        this.vector.getSource().addFeatures({
          features: (new GeoJSON()).readFeatures(coordinates)
        });
      }
    }
    this.createLayers(initObj);

    const mZoom = (this.type === 1 ? 12 : 19); // 13885 && 13924-2
    this.view = this.setView(this.defaultLon, this.defaultLat, this.defaultZoom, this.EPSG,
      initObj.minResolution, initObj.maxResolution, mZoom); //

    if (coordinates) {
      this.clampZoomFloor();
    }

    const controls = (initObj.controls) ? initObj.controls : [];
    this.map = this.initializeMap(initObj, controls, this.view  , null , this.tileLayers);

    // 13835 : zoom-in/out, i, fullscreen control
    const lst: any = document.querySelectorAll('.ol-overlaycontainer-stopevent'); // ol v4.6.5
    if (lst != null && lst.length > 0) {
      for (let i = 0; i < lst.length; i++) {
        lst[i].style.zIndex = this.layerIndexControl;
        const childs = lst[i].children;
        if (childs == null || childs.length === 0) { continue; }

        for (let j = 0; j < childs.length; j++) {
          childs[j].style.zIndex = this.layerIndexControl;
        }
      }
    }

    let numInFlightTiles = 0;
    this.map.getLayers().forEach(function(layer) {
      if (layer.type && layer.type === 'TILE') {
        const source = layer.getSource();
        if (source instanceof TileImage) {
          source.on('tileloadstart', function() {numInFlightTiles++; });
          source.on('tileloadend', function() {numInFlightTiles--; });
        }
      }

    });
    this.map.on('postrender', (evt) => {
      if (!evt.frameState) {
        return;
      }

      let numHeldTiles = 0;
      const wanted = evt.frameState.wantedTiles;
      for (const layer in wanted) {
        if (wanted.hasOwnProperty(layer)) {
          numHeldTiles += Object.keys(wanted[layer]).length;
        }
      }

      const ready = numInFlightTiles === 0 && numHeldTiles === 0;
      if (this.map.get('ready') !== ready) {
        this.map.set('ready', ready);
        if (this.type === 3 && this.bounds) {
          this.view.fit(this.bounds);

          if (this.fitCoordCount === 1) {
            let currentZoom = this.view.getZoom();
            currentZoom = currentZoom - 2;
            if (currentZoom < 0) { currentZoom = 1; }
            this.view.setZoom(currentZoom);
          }
          this.clampZoomFloor();
          // console.log('%c , map.ready = ' + ready + ', sc-selected-asset clamp Zoom' , 'color:blue' );
          this.bounds = null; // reset
        }
        if (ready) {
          if (this.canvas == null) { this.canvas = document.querySelector(initObj.mapId + ' canvas'); }
          this.checkMapEmpty(this.canvas);
          this.isMapReady = true;
        }
      }

    });
    this.map.set('ready', false);
    function whenMapIsReady(callback) {
      if (this.map.get('ready')) {
        callback();
      } else {
        this.map.once('change:ready', whenMapIsReady.bind(null, callback));
      }
    }

    const lstCv = initObj.target.getElementsByTagName('canvas');
    if (lstCv && lstCv.length > 0) {
      const cv = lstCv[0];
      this.canvas = cv;
    }

    if (initObj.componentDefinition && (typeof initObj.componentDefinition.visible === 'undefined' ||
      initObj.componentDefinition.visible )) {
      let mapWidth = this.map.getSize()[0]; let mapHeight = this.map.getSize()[1];
      let wrapperWitdh = ( this.divWrapper ? this.divWrapper.offsetWidth : mapWidth );
      let wrapperHeight = ( this.divWrapper ? this.divWrapper.offsetHeight : mapHeight );

      let count = 0; // make sure checkCanvasId don't run forever if some exception cases happening
      const limitCheckCanvas = 10; // make sure checkCanvasId don't run forever if some exception cases happening
      const checkCanvasId = setInterval(() => {
        mapWidth = this.map.getSize()[0];
        mapHeight = this.map.getSize()[1];
        wrapperWitdh = ( this.divWrapper ? this.divWrapper.offsetWidth : mapWidth );
        wrapperHeight = ( this.divWrapper ? this.divWrapper.offsetHeight : mapHeight );
        // console.log('this.canvas = ' + this.canvas + ', mapWidth = ' + mapWidth
        // + ', mapHeight = ' + mapHeight + ', wrapperWitdh = ' + wrapperWitdh
        // + ', wrapperHeight = ' + wrapperHeight);
        if (this.canvas) {
          if (this.canvas.style.display === 'none' || mapWidth <= 0 || wrapperWitdh !== mapWidth || mapHeight <= 0 ||
            wrapperHeight !== mapHeight) {
            this.show = true;
            this.canvas.style.display = 'block';
            this.map.setSize(wrapperWitdh, wrapperHeight);
            this.map.updateSize();
            if (initObj.watchDocFn && typeof initObj.watchDocFn === 'function') {
              const doc = initObj.watchDocFn();
              const extent = this.vector.getSource().getExtent();
              if (extent != null && extent.length === 4 && isFinite(extent[0])
              && isFinite(extent[1]) && isFinite(extent[2]) && isFinite(extent[3])) {
                this.map.getView().fit(extent, [500, 500], { maxZoom: 15 });
                this.clampZoomFloor();
              }
            }
            if (initObj.style === 2) {
              this.fit(initObj.configService, null, initObj.initialZoomChange, null); // test test
            }
            // console.log('map update size , width = ' + mapWidth + ', height = ' + mapHeight
            // + ', wrapperWitdh = ' + wrapperWitdh + ', wrapperHeight = ' + wrapperHeight);
          } else {
            clearInterval(checkCanvasId);
          }
        } else {
          const lstCv1 = initObj.target.getElementsByTagName('canvas');
          if (lstCv1 && lstCv1.length > 0) {
            const cv = lstCv1[0];
            this.canvas = cv;
          }
        }

        // if we have map control then put to map
        this.setupMapControl();
        if (this.layersRedraw === true && this.testDiv !== null) {
          const offsetHeight = this.testDiv.offsetHeight;
          const top = mapHeight - offsetHeight;
          const css = {top: top + 'px', left: '10px', display: 'flex'};
          Object.assign(this.testDiv.style, css);
        }

        count++;
        if (count > limitCheckCanvas) {
          console.log('%c out of limit check canvas', 'color:blue');
          clearInterval(checkCanvasId);
        }
      }, 500);

      setTimeout(() => {
        if (mapWidth === wrapperWitdh &&
          this.wmsState.hasTile &&
          this.wmsState.hasEvent === false &&
          this.wmsState.finishLoad === false) {
          // Changed Notification to logger message as errors are not helpful in most cases
          console.log('There has been an error returned from the mapping service tileloader - is the map visible?');
        }
      }, 1000);

      if (initObj.toolTipOnFeatureHover && typeof initObj.toolTipOnFeatureHover === 'function') {
        this.toolTipOnFeatureHover = initObj.toolTipOnFeatureHover;
      }

    }

    // TO DO : make sure canvas won't effect by some div parent is hidden when init map
    // scope.$watch('tplItem.visible', function(value) {
    //     if(value && self.map != null){

    //         if(typeof cv !== 'undefined' || cv != null){
    //             let checkCanvasId2 = setInterval(function(){
    //                 let mapWidth = self.map.getSize()[0], mapHeight = self.map.getSize()[1];
    //                 if(cv.style.display == 'none' || mapWidth <= 0 || mapHeight <= 0){
    //                     scope.show = true;
    //                     cv.style.display = 'block';
    //                     self.map.updateSize();
    //                     UtilService.safeApply(scope);
    //                 }
    //                 else{
    //                     clearInterval(checkCanvasId2);
    //                     if(initObj.style == 2){
    //                         self.fit(initObj.configService, null, initObj.initialZoomChange);
    //                     }
    //                 }
    //             }, 500);
    //         }
    //     }
    // }, true);


    // test test
    this.checkMapLoadDone = setInterval(() => {
      if (this.wmsState.finishLoad) {
        // console.log('%c checkMapLoadDone FINISH', 'color:blue');
        clearInterval(this.checkMapLoadDone);
        this.checkMapLoadDone = null;

        if (this.setupMapDone) { this.setupMapDone(); }

        if (this.setupTooltipUI && (typeof this.setupTooltipUI === 'function')) {
          this.setupTooltipUI();
          this.setupTooltipUI = null; // call one time when init map
        }

      }
    }, 500);
  }
  checkIsFullScreenSupport() {
    const body: any = document.body;
    return !!(
        body.webkitRequestFullscreen ||
        (body.mozRequestFullScreen) ||
        (body.msRequestFullscreen) ||
        (body.requestFullscreen)
    );
  }
  setupMapControl() {
    if (this.elementCtrl != null) {
      if (this.heightNum < 3) {
        this.elementCtrl.classList.add('ol-custom-control-bottom'); // must define this class in css of each component
      } else {
        this.elementCtrl.classList.add('ol-custom-control'); // must define this class in css of each component
      }
      if (this.type === 0 && this.heightNum < 3 || (this.type === 3 &&  this.heightNum === 1)) {// sc-boundary
        this.mapControlStyle(this.elementCtrl, true, this.mapDiv.offsetHeight);
      } else {
        this.mapControlStyle(this.elementCtrl, false, this.mapDiv.offsetHeight);
      }
    }
  }
  mapControlStyle(elem, isBottom, mapHeight) {
    if (this.elementCtrl == null) { return {}; }

    if (isBottom) {
      elem.style.bottom = '10px';
      elem.style.display = 'flex';
    } else {
      const offsetHeight = this.elementCtrl.offsetHeight;
      const offsetWidth = this.elementCtrl.offsetWidth;
      let elemHeight = offsetHeight;
      if (offsetHeight < offsetWidth) { elemHeight = offsetWidth; }
      const top = (mapHeight / 2) - (elemHeight / 2);
      elem.style.top = top + 'px';
      // console.log('%c offsetHeight = ' + offsetHeight + ', offsetWidth = ' + offsetWidth
      //  + ', elemHeight = ' + elemHeight  + ', mapHeight = ' + mapHeight + ', top = ' + top
      //   + ', elem.style.top = ' + elem.style.top, 'color:blue');
      elem.style.setProperty ('display', 'grid', 'important');

    }
  }

  mapMoveEnd(moveEndFunc) {
    this.map.on('moveend', moveEndFunc);
  }

  createTextStyle(label, color, type) {

    const currentZoom = this.view.getZoom();
    const displayZoom = (!label.labelDisplayZoom ? 9: (label.labelDisplayZoom > 17 ? 17 : label.labelDisplayZoom));
    const text = (currentZoom < displayZoom ? '': (label.labelText ? label.labelText: ''));
    const align = (label.labelTextAlign === '' || label.labelTextAlign == null) ? undefined : label.labelTextAlign;
    const baseLine = (label.labelTextBaseline === '' || label.labelTextBaseline == null) ? undefined : label.labelTextBaseline;
    const fillColor = (label.labelColor === '' || label.labelColor == null ) ? color : label.labelColor;
    const outlineColor = (label.labelOutlineColor === '' || label.labelOutlineColor == null) ? 'white' : label.labelOutlineColor;
    const outlineWidth = (label.labelOutlineWidth === '' || label.labelOutlineWidth == null
     || label.labelOutlineWidth === 0) ? 5 : label.labelOutlineWidth;
    const offsetX = (label.labelOffsetX === '' || label.labelOffsetX == null || label.labelOffsetX === 0) ? 0 : label.labelOffsetX;
    const offsetY = (label.labelOffsetY === '' || label.labelOffsetY == null || label.labelOffsetY === 0) ? 0 : label.labelOffsetY;
    let placement = (label.labelPlacement === '' || label.labelPlacement == null) ? 'point' : label.labelPlacement;
    const maxAngle = (label.labelMaxAngle === '' || label.labelMaxAngle == null) ? 90 : parseFloat(label.labelMaxAngle);
    const overflow = (typeof label.labelOverflow !== 'undefined' && label.labelOverflow !== null) ? label.labelOverflow : true;
    const rotationWithView = ( label.labelRotationWithView === true);
    const rotation = (label.labelRotation === '' || label.labelRotation == null) ? 0 : label.labelRotation;
    const padding = (label.labelPadding === '' || label.labelPadding == null) ? undefined : label.labelPadding;
    const weight = (label.labelFontWeight === '' || label.labelFontWeight == null) ? 'normal' : label.labelFontWeight;
    let size = (label.labelFontSize === '' || label.labelFontSize == null || label.labelFontSize === 0) ? '12px' : label.labelFontSize;
    const fontValue = (label.labelFont === '' || label.labelFont == null) ? 'Arial' : label.labelFont;

    if (typeof size === 'string') { size = size.replace('px', ''); }
    const font = weight + ' ' + size + 'px ' + fontValue;
    // rotation = rotation * 3.14 / 180;
    if (type === 'Point') { placement = 'point'; }

    return new Text({
      textAlign: align,
      textBaseline: baseLine,
      font,
      text,
      fill: new Fill({color:  fillColor}),
      stroke: new Stroke({color: outlineColor, width: outlineWidth}),
      offsetX,
      offsetY,
      placement,
      maxAngle,
      overflow,
      rotationWithView,
      rotation,
      padding
    });
  }
  updateLabelByZoom() {
    const currentZoom = this.view.getZoom();

    for (let i = 1; i < this.layerAssets.length; i++) {
        try {
            if (this.layerAssets[i].get('isCluster') || !this.layerAssets[i].getSource()) {
                continue;
            }
            this.layerAssets[i].getSource().getFeatures().forEach((fea) => {
                const lb = fea.get('label');
                if (lb) {
                  const displayZoom = (!lb.labelDisplayZoom ? 9: (lb.labelDisplayZoom > 17 ? 17 : lb.labelDisplayZoom));
                  const text = (currentZoom < displayZoom ? '': (lb.labelText ? lb.labelText: ''));
                  const style = fea.getStyle();
                  if (style && style.length > 0) {
                    const txt = style[0].getText();
                    if (txt) {
                      txt.setText(text);
                      fea.setStyle(style);
                    }
                  }
                }
            });
        } catch (err) {
            console.log(err);
        }
    }
  }
  getAnchor(icon, anchor) {
    if (( icon === sclMapConstant.MAP_MARKER || icon === sclMapConstant.MAP_PRIMARY_ASSET
      || icon === sclMapConstant.MAP_SECONDARY_ASSET ) && anchor == null) {
      anchor = [0.5, 1.0]; // system defined Images
    }
    if (anchor == null) { anchor = [0.5, 0.5]; }// no image anchor & is override image

    return anchor;
  }
  updateLabel(feature, label) {
    const currentZoom = this.view.getZoom();
    const displayZoom = (!label.labelDisplayZoom ? 9: (label.labelDisplayZoom > 17 ? 17 : label.labelDisplayZoom));
    const text = (currentZoom < displayZoom ? '': (label.labelText ? label.labelText: ''));
    if (this.type === 1) { // sc-address-map
      const style = feature.getStyle();
      if (style && style.length > 0) {
        const txt = feature.getStyle()[0].getText();
        if (txt) { txt.setText(text); }
      }
    }
  }

  getPointStyle(color, icon, imageAnchor, geom, label, t, rotation) {
    let pointColor = 'green';
    if (color) {pointColor = color; }
    let image = null;
    if (icon) {
      let anchor = imageAnchor;
      anchor = this.getAnchor(icon, anchor);
      const angle = (rotation ? (rotation * (Math.PI/180)): 0);
      image = new Icon(({
        src: icon,
        anchor,
        rotation: angle
      }));
    } else {
      image = new Circle({
        radius: 7,
        fill: new Fill({
          color: pointColor// '#ffcc33'
        })
      });
    }
    const style = new Style({
      fill: new Fill({
        color: 'rgba(255, 255, 255, 0.2)'
      }),
      stroke: new Stroke({
        color: pointColor,
        width: 2
      }),
      image
    });
    // return style;
    const styles = [style];

    // label style
    if (label != null) {
      style.setText(this.createTextStyle(label, color, t));
    }
    return styles;
  }
  getPointStyleScale(feature, p, style) {
    let scaleX = 1;
    let scaleY = 1;
    if (p.scale) {
      if (Array.isArray(p.scale) && p.scale.length == 2) {
        // console.log('getPointStyleScale, scale is array, p.scale = ', p.scale);
        scaleX = p.scale[0];
        scaleY = p.scale[1];
      } else if (isNumber(p.scale)) {
        // console.log('getPointStyleScale, scale is number, p.scale = ' + p.scale);
        scaleX = p.scale;
        scaleY = p.scale;
      }
      
    }
    // load image event
    const img = new Image();
    img.src = p.icon;

    img.onload = () => {
      this.countGetImgSrc++;
      feature.set('size', [img.width, img.height]);
      let maxSize = img.width;
      if (img.width < img.height) { maxSize = img.height; }
      if (this.fitPadding < maxSize) {
        this.fitPadding = maxSize;
      }
      if (scaleX != 1 || scaleY != 1) {
        // console.log('image scale & flip');
        style.setImage(this.drawImage(img, scaleX, scaleY, style));
      }
      
      
      // console.log('image onload');
    };
  }

  getMultiPointStyle(properties) {
    let strokeColor = 'blue'; let fillColor = 'blue';
    if (properties.color) { strokeColor = properties.color; }
    if (properties.fillColor) { fillColor = properties.fillColor; }
    let image = new Circle({
      radius: 7,
      fill: new Fill({
        color: fillColor// '#ffcc33'
      })
    });
    const styles = [];
    const style = new Style({
      image
    });
    if (properties.icon) {
      let anchor = [0.5, 1];
      if (properties.anchor) { anchor = properties.anchor; }

      anchor = this.getAnchor(properties.icon, anchor);

      image = new Icon(
        ({
          src: properties.icon,
          anchor
        })
      );
    }

    const stroke = new Stroke({
      color: strokeColor,
      width: 2
    });
    style.setStroke(stroke);
    if (properties && properties.fillColor) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) {color[3] = properties.fillOpacity; }  // change the alpha of the color

      fillColor = color;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);
    styles.push(style);

    return styles;
  }

  getLineStyle(pColor, properties, geom, t) {
    let lineColor = 'blue';
    if (pColor) { lineColor = pColor; }
    const styles = [];
    const style = new Style({
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33'
        })
      })
    });
    const stroke = new Stroke({
      color: lineColor,
      width: 2
    });
    if (properties) {
      if (properties.lineWidth) {stroke.setWidth(properties.lineWidth); }
      if (properties.lineDash) {stroke.setLineDash(properties.lineDash); }
      if (properties.lineCap) {stroke.setLineCap(properties.lineCap); }
    }
    
    let fillColor = 'rgba(255, 255, 255, 0.2)';
    if (properties && properties.fillColor) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) {color[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = 'rgba(' + color[0] + ', ' + color[1] + ', ' + color[2] + ', ' + color[3] + ')';
      stroke.setColor(fillColor);
    }
    style.setStroke(stroke);
    styles.push(style);

    // label style
    if (typeof properties.label !== undefined && properties.label != null ) {
      style.setText(this.createTextStyle(properties.label, pColor, t));
    }

    return styles;
  }

  lableStyle(geom, label, color, t) {
    return new Style({
      geometry: geom,
      text : this.createTextStyle( label, color, t)
    });
  }

  colorWithAlpha(color, alpha) {
    let c = olColor.asArray(color);
    c = c.slice();
    c[3] = alpha;
    return c;
  }

  // sc-boundary
  styleBoundary(feature) {
    if (feature == null) { return; }// feature is null
    const type = feature.getGeometry().getType();
    if (type && type.indexOf('Multi') > -1) {
      return new Style({
        fill: new Fill({
          color: this.colorWithAlpha(this.multiColor, 0.3), // 'rgba(255, 255, 255, 0.2)',
        }),
        stroke: new Stroke({
          color: this.multiColor,
          width: 2
        }),
        image: new Circle({
          radius: 7,
          fill: new Fill({
            color: this.multiColor
          })
        })
      });
    } else {
      const p = feature.getProperties();
      if (p && p.icon) {
        let anchor = [0.5, 1]; // system defined image
        if (p.icon === sclMapConstant.MAP_PRIMARY_ASSET || p.icon === sclMapConstant.MAP_SECONDARY_ASSET
          || p.icon === sclMapConstant.MAP_MARKER) {
          anchor = [0.5, 1]; // system defined image
        } else {
          anchor = [0.5, 0.5]; // no image anchor & is override image , sc-boundary has no anchor config entry
        }
        const iconStyle = new Icon(({
          src: p.icon,
          anchor
        }));
        return new Style({
          image: iconStyle
        });
      } else {
        return new Style({
          fill: new Fill({
            color: this.colorWithAlpha(this.color, 0.3)// 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new Stroke({
            color: this.color,
            width: 2
          }),
          image: new Circle({
            radius: 7,
            fill: new Fill({
              color: this.color
            })
          })
        });
      }
    }

  }

  // sc-address-map
  styleAddress(feature, resolution) {
    if (feature == null) { return; }// feature is null
    let p = feature.getProperties();
    if (p.features && p.features.length > 0) { // cluster style
      p = p.features[0].getProperties();
    }
    let color = p.color;
    let t = 'Line';
    const fIndex = p.zIndex;

    let style = [];
    if (feature.getGeometry() && feature.getGeometry().getType() === 'Point') {
      t = 'Point';
      // style = this.getPointStyle(color, p.icon, p.anchor, feature.getGeometry(), p.label, t);
      if (fIndex === this.layerIndexUser) {
        color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color);
        style = this.getPointSelectionStyle(feature, color, this.selectionStyle);
      } else {
        style = this.getPointStyle(color, p.icon, p.anchor, feature.getGeometry(), p.label, t, p.rotation);
        if (p.icon && !p.size) {
          // console.log('getPointStyleScale');
          this.getPointStyleScale(feature, p, style[0]);
        } else {
          // console.log('getPointStyle');
          this.countGetImgSrc++;
        }
      }
      
      
    } else if (feature.getGeometry() && feature.getGeometry().getType() === 'MultiPoint') {
      if (fIndex === this.layerIndexUser) {
        color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color);
        style = this.getMultiPointSelectedStyle(p, this.selectionStyle);
      } else {
        style = this.getMultiPointStyle(p);
      }
    } else {
      if (fIndex === this.layerIndexUser) {
        color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color);
        style = this.getLineSelectionStyle(p, color, this.selectionStyle);
      } else {
        style = this.getLineStyle(color, p, feature.getGeometry(), t);
      }
    }

    return style;
  }
  drawImage(img, scaleX, scaleY, oldStyle) {
    const x = Math.round(img.width * scaleX);
    const y = Math.round(img.height * scaleY);
    const canvas = document.createElement('canvas');
    canvas.width = Math.abs(x);
    canvas.height = Math.abs(y);
    var ctx = canvas.getContext('2d');

    ctx.translate(Math.abs(Math.min(0,x)), Math.abs(Math.min(0,y)));
    ctx.scale(x<0 ? -1 : 1, y<0 ? -1 : 1);

    ctx.drawImage(img, 0, 0, Math.abs(x), Math.abs(y));
    const dataUrl = canvas.toDataURL();
    canvas.remove();

    // console.log('typeof oldStyle = ' + (typeof oldStyle));
    // const im = oldStyle.getImage();
    // console.log('image = ', im);
    const anchor = oldStyle.getImage().anchor_;
    const angle = oldStyle.getImage().getRotation();
    // console.log('anchor = ', anchor);
    // console.log('angle = ' + angle);
    const iconOptions = {
      src: dataUrl,
      anchor,
      rotation: angle
    };
    return new Icon(iconOptions);
  }

  // sc-street-address
  styleStAddress(feature, resolution) {
    if (feature == null) { return; }// feature is null
    const styles = {
      Point: [new Style({
        image: sclMapConstant.MAP_MARKER,
        anchor: [0.5, 1]// system defined image
      })],
      LineString: [new Style({
        stroke: new Stroke({
          color: 'blue',
          width: 2
        })
      })]
    };
    if (feature.getProperties() && feature.getGeometry().getType() === 'Point') {
      const type = feature.getProperties().typeFeature;
      if (type && type === 'tree') {
        console.log('TODO - determine what image should be displayed for the tree type');
        return new Style({
          //     image
        });
      }
      if (feature.getProperties().icon) {
        const style = new Style({
          image: new Icon(({
            src: feature.getProperties().icon,
            anchor: [0.5, 1]// system defined image
          }))
        });
        return style;
      }
    }

    return styles[feature.getGeometry().getType()];
  }

  // sc-selected-asset
  styleAsset(feature, resolution) {
    if (feature == null) { return; }// feature is null

    let p = feature.getProperties();
    if (p.features && p.features.length > 0) { // cluster style
      p = p.features[0].getProperties();
    }
    const color = p.color;
    let t = 'Line';
    if (feature.getGeometry() && feature.getGeometry().getType() === 'Point' ) {
      t = feature.getGeometry().getType(); // "Point";
      let anchor = p.anchor;

      const assetType = feature.get('assetType');
      const id = p.id;
      const zIndex = '';
      if (id === 'address') {
        // zIndex = 1000;
        anchor = this.addressImageAnchor;
      }
      if (assetType === sclMapConstant.ASSET_PRIMARY_TYPE) {
        // zIndex = 1000;
        anchor = this.primaryImageAnchor;
      }
      if (assetType === sclMapConstant.ASSET_SECONDARY_TYPE) {
        // zIndex = 1000;
        anchor = this.secondaryImageAnchor;
      }
      anchor = this.getAnchor(p.icon, anchor);

      const pointStyle = this.getPointStyle(color, p.icon, anchor, feature.getGeometry(), p.label, t, p.rotation);
      if (p.icon && !p.size) {
        this.getPointStyleScale(feature, p, pointStyle[0]);
      }
      feature.set('feaStyle', pointStyle);
      return pointStyle;
    } else if (feature.getGeometry() && feature.getGeometry().getType() === 'MultiPoint') {
      return this.getMultiPointStyle(p);
    } else {
      const lineStyle = this.getLineStyle(color, p, feature.getGeometry(), t);
      return lineStyle;
    }
  }

  // use for primary selected asset
  stylePrimaryAssetFunc(feature, resolution) {
    return this.styleSelectedAssetFunc(feature, this.primaryAssetSelection);
  }

  // use for secondary selected asset
  styleSecondaryAssetFunc(feature, resolution) {
    return this.styleSelectedAssetFunc(feature, this.secondaryAssetSelection);
  }

  styleSelectedAssetFunc(feature, assetSelection) {
    if (feature == null) { return; }
    let style = [];
    const p = feature.getProperties();
    const geom = feature.getGeometry();
    let t = geom.getType();
    if (p && p.layerDisplayOnly) {
      if (p && t === 'Point') {
        style = this.getPointStyle(p.color, p.icon, p.anchor, null, null, null, p.rotation);
        feature.set('feaStyle', style);
      } else {
        style = this.getLineStyle(p.color, p, null, null);
      }
      return style;
    }
    let color = (assetSelection && assetSelection.selectionColor ? assetSelection.selectionColor : p.color) ;
    if (geom && t === 'Point') {
      t = 'Point';
      style = this.getPointSelectionStyle(feature, color, assetSelection);
      feature.set('feaStyle', style);
    } else if (t === 'MultiPoint') {
      style.push(this.getMultiPointSelectedStyle(p, assetSelection));
    } else {
      style.push(this.getLineSelectionStyle(p, color, assetSelection));
    }
    if (typeof p.label !== undefined && p.label != null) {
      color = p.color;
      style.push(this.lableStyle(geom, p.label, color, t));
    }
    
    return style;
  }

  // copy from sclStyleUtil.getPointSelectionStyle
  getPointSelectionStyle(feature, color, selection) {

    const p = feature.getProperties();
    let icon = p.icon;
    let anchor = p.anchor;
    if (selection) {
      if (selection.selectionImageFileNo) {
        icon = selection.selectionImageFileNo; // 15783 // '/api/getFile/' + selection.selectionImageFileNo;
      }
      if (selection.selectionImageAnchor) {
        anchor = selection.selectionImageAnchor;
      }
    } else {
      if (icon === sclMapConstant.MAP_PRIMARY_ASSET) { anchor = this.primaryImageAnchor;
      } else if (icon === sclMapConstant.MAP_SECONDARY_ASSET) { anchor = this.secondaryImageAnchor;
      } else if (icon === sclMapConstant.MAP_MARKER) { anchor = [0.5, 1]; }// system defined image
    }
    if (anchor === undefined || anchor === null) {
      if (icon === sclMapConstant.MAP_PRIMARY_ASSET || icon === sclMapConstant.MAP_SECONDARY_ASSET
        || icon === sclMapConstant.MAP_MARKER) {
        anchor = [0.5, 1]; // system defined image
      } else {
        if (typeof p.assetType !== 'undefined' && p.assetType === 'primary' && this.primaryImageAnchor !== undefined) {
          anchor = this.primaryImageAnchor;
        } else if (typeof p.assetType !== 'undefined' && p.assetType === 'secondary' && this.secondaryImageAnchor !== undefined) {
          anchor = this.secondaryImageAnchor;
        } else { anchor = [0.5, 0.5]; }// no image anchor & is override image
      }
    }
    let iconStyle = null;
    if (icon) {
      iconStyle = new Icon(({
        src: icon,
        anchor
      }));
    } else {
      iconStyle = new Circle({
        radius: 7,
        fill: new Fill({
          color: color // '#ffcc33'
        })
      });
    }
    if (selection && selection.selectionImageAnchor) {
      iconStyle = new Icon(({
        src: icon,
        anchor
      }));
    }
    const stylePoint = [new Style({
      image: iconStyle,
      // zIndex: 10
    })];
    return stylePoint;
  }

  // copy from sclStyleUtil.getLineSelectionStyle
  getLineSelectionStyle(properties, color, selection) {
    if (properties.type === 'MultiPoint') {
      const multiPointStyle =  this.getMultiPointSelectedStyle(properties, selection);

      return multiPointStyle;
    } else {
      const lineStyle =  this.getLineStyle2(color, properties);
      if (selection) {
        if (selection.selectionColor) {
          lineStyle.getStroke().setColor(selection.selectionColor);
        }
        if (selection.selectionLineDash) {
          if (Array.isArray(selection.selectionLineDash)) { lineStyle.getStroke().setLineDash(selection.selectionLineDash); }
        }
        if (selection.selectionLineWidth) {lineStyle.getStroke().setWidth(selection.selectionLineWidth); }
        if (selection.selectionLineCap) {lineStyle.getStroke().setLineCap(selection.selectionLineCap); }
        if (selection.selectionFill) {
          let color1 = olColor.asArray(selection.selectionFill);
          color1 = color1.slice();
          if (selection.selectionFillOpacity) {color1[3] = selection.selectionFillOpacity; }
          lineStyle.getFill().setColor(color1);
        }
      }
      return lineStyle;
    }
  }

  getLineStyle2(color, properties) {
    let lineColor = 'blue';
    if (color) { lineColor = color; }

    const style = new Style({
      image: new Circle({
        radius: 7,
        fill: new Fill({
          color: '#ffcc33'
        })
      })
    });

    const stroke = new Stroke({
      color: lineColor,
      width: 2
    });
    if (properties) {
      if (properties.lineWidth) {stroke.setWidth(properties.lineWidth); }
      if (properties.lineDash) {stroke.setLineDash(properties.lineDash); }
      if (properties.lineCap) {stroke.setLineCap(properties.lineCap); }
    }
    style.setStroke(stroke);
    let fillColor = 'rgba(255, 255, 255, 0.2)';
    if (properties && properties.fillColor) {
      let color1 = olColor.asArray(properties.fillColor);
      color1 = color1.slice();
      if (properties.fillOpacity) {color1[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = color1;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);
    return style;
  }

  getMultiPointSelectedStyle(properties, selection) {
    let strokeColor = '#ffcc33'; let fillColor = '#ffcc33';
    if (properties.color) { strokeColor = properties.color; }
    if (properties.fillColor) { fillColor = properties.fillColor;
    } else { fillColor = strokeColor; }
    if (selection && selection.selectionColor) {
      strokeColor = selection.selectionColor;
      fillColor = selection.selectionColor;
    }
    let image = new Circle({
      radius: 7,
      fill: new Fill({
        color: fillColor
      })
    });
    const style = new Style({
      image
    });
    if (properties.icon) {
      const icon = properties.icon;
      let anchor = properties.anchor;
      if (selection && selection.selectionImageAnchor) {
        anchor = selection.selectionImageAnchor;
      } else {
        if (icon === sclMapConstant.MAP_PRIMARY_ASSET) {
          anchor = this.primaryImageAnchor;
        } else if (icon === sclMapConstant.MAP_SECONDARY_ASSET) {
          anchor = this.secondaryImageAnchor;
        }
      }
      if (anchor === undefined || anchor === null) {
        if (icon === sclMapConstant.MAP_PRIMARY_ASSET || icon === sclMapConstant.MAP_SECONDARY_ASSET) {
          anchor = [0.5, 1]; // system defined image
        } else {
          if (typeof properties.assetType !== 'undefined' && properties.assetType === 'primary' && this.primaryImageAnchor !== undefined) {
            anchor = this.primaryImageAnchor;
          } else if (typeof properties.assetType !== 'undefined' && properties.assetType === 'secondary' &&
            this.secondaryImageAnchor !== undefined) {
            anchor = this.secondaryImageAnchor;
          } else {
            anchor = [0.5, 0.5];
          } // no image anchor & is override image
        }
      }
      image = new Icon(
        ({
          src: icon,
          anchor
        })
      );
    }

    const stroke = new Stroke({
      color: strokeColor,
      width: 2
    });
    style.setStroke(stroke);
    if (properties && properties.fillColor) {
      let color = olColor.asArray(properties.fillColor);
      color = color.slice();
      if (properties.fillOpacity) {color[3] = properties.fillOpacity; }  // change the alpha of the color
      fillColor = color;
    }
    const fill = new Fill({
      color: fillColor
    });
    style.setFill(fill);

    return style;
  }

  styleSelectedFunc(feature, resolution) {
    if (feature == null) { return; }
    let style = [];
    const p = feature.getProperties();
    const geom = feature.getGeometry();
    let t = geom.getType();
    let color = (this.selectionStyle && this.selectionStyle.selectionColor ? this.selectionStyle.selectionColor : p.color) ;
    if (geom && t === 'Point') {
      t = 'Point';
      style = this.getPointSelectionStyle(feature, color, this.selectionStyle);
    } else {
      style.push(this.getLineSelectionStyle(p, color, this.selectionStyle));
    }
    if (typeof p.label !== undefined && p.label != null) {
      color = p.color;
      style.push(this.lableStyle(geom, p.label, color, t));
    }
    return style;
  }

  addStyleControlButton(btn, zoomOptions) {
    btn.onmouseover = () => {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'lightgrey';
      if (zoomOptions) {
        if (zoomOptions.isZoomIn) {
          btn.setAttribute('title', 'Zoom in (' + this.view.getZoom() + ')');
        } else {
          btn.setAttribute('title', 'Zoom out (' + this.view.getZoom() + ')');
        }
      }
    };
    btn.onmouseout = () => {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'white';
    };

    btn.onclick = () => {
      this.hasClickButtonZoom = true;
    };
  }

  initializeMap(initObj, controls, view, mapLayers, multiLayers) {
    const ConfigService = initObj.configService;
    const interactions = initObj.interactions;
    const disableMouseWheel = initObj.disableMouseWheel;
    let sourceXYZ = [];
    if (multiLayers && multiLayers.length > 0) {
      sourceXYZ = multiLayers;
    } else {
      if (mapLayers) {
        sourceXYZ.push(mapLayers);
      } else {
        const tile = new TileLayer({
          source: new OSM({
            url: 'https://osm.formbird.com/tiles/{z}/{x}/{y}.png', // ConfigService.clientConfig().openLayers.tileServer.url,
            // crossOrigin: ConfigService.clientConfig().openLayers.tileServer.crossOrigin,
            wrapDateLine: false,
            wrapX: false,
            noWrap: true
          })
        });
        sourceXYZ.push(tile);
      }
    }

    let mouseWheel = true;
    if (disableMouseWheel) {
      mouseWheel = false;
    }

    // define full screen button icon
    const fspan = document.createElement('i');
    fspan.setAttribute('class', 'material-icons');
    fspan.innerHTML = 'fullscreen';
    fspan.style.fontSize = '30px';

    const fSpanActive = document.createElement('i');
    fSpanActive.setAttribute('class', 'material-icons');
    fSpanActive.innerHTML = 'fullscreen_exit';
    fSpanActive.style.fontSize = '30px';
    const fullscreenCtrl = new FullScreen({
      label: fspan, labelActive: fSpanActive, tipLabel: 'Fullscreen'
    });
    const fullscreenBtn = fullscreenCtrl.element.childNodes[0];
    this.addStyleControlButton(fullscreenBtn, null);


    document.addEventListener('fullscreenchange', (evt) => {
     this.fullscreenChangeHandle(fspan);
    });
    document.addEventListener("webkitfullscreenchange", (evt) => { this.fullscreenChangeHandle(fspan); }, false);
    document.addEventListener("mozfullscreenchange", (evt) => { this.fullscreenChangeHandle(fspan); }, false);

    // define zoom button
    const zoomBtn = new Zoom({
      className: 'ol-zoom my-new-class-name'
    });
    const zoomBtnIn = zoomBtn.element.childNodes[0]; const zoomBtnOut = zoomBtn.element.childNodes[1];
    this.addStyleControlButton(zoomBtnIn, {isZoomIn: true});
    this.addStyleControlButton(zoomBtnOut, {isZoomIn: false});

    if (initObj.componentDefinition) {
      let clConfig;
      if ( initObj.configService) {
        clConfig = initObj.configService.clientConfig();
      }
      if (initObj.componentDefinition.tileServerGL && clConfig && clConfig.openLayers && clConfig.openLayers.tileServerGL) {
        const mapUrl = clConfig.openLayers.tileServerGL.url;
        const layerMVT = new VectorTileLayer({
          source: new VectorTileSource({
            format: new MVT({featureClass: Feature}),
            url: mapUrl,
            maxZoom: 14
          })
        });
        // const layerXYZ = new TileLayer({
        //   source: new XYZ({
        //     url: 'http://admina-virtualbox:8080/styles/basic-preview/{z}/{x}/{y}.png'
        //   } )
        // } );
        const styleUrl = mapUrl.replace('data/v3/{z}/{x}/{y}.pbf', 'styles/basic-preview/style.json');
        fetch(styleUrl).then(function(response) {
          response.json().then(function(glStyle) {
            styleFunction(layerMVT, glStyle, 'openmaptiles');
          });
        });
        sourceXYZ = [layerMVT];
      }
    }
    const map = new Map({
      controls: olControl.defaults({
        attribution : false,
        zoom: false,
      }).extend([
        fullscreenCtrl,
        zoomBtn
      ]),
      interactions: defaults({mouseWheelZoom: mouseWheel}),
      layers: sourceXYZ,
      target: this.mapDiv,
      view
    });
    // console.log('%c initializeMap, zoom = ' + view.getZoom() , 'color:blue');
    if (controls != null && controls.length) {
      for (let i = 0; i < controls.length; i++) {
        controls[i].element.style.zIndex = this.layerIndexControl;
        map.addControl(controls[i]);
      }
    }

    if (interactions != null && interactions.length) {
      for (let i = 0; i < interactions.length; i++) {
        map.addInteraction(interactions[i]);
      }
    }

    if (this.layerAssets.length > 0) {
      for (let iLa = 0; iLa < this.layerAssets.length; iLa++) {
        map.addLayer(this.layerAssets[iLa]);
      }
    }

    if (mouseWheel) {
      if (this.onMapWheelScroll && typeof this.onMapWheelScroll === 'function') {
        this.mapDiv.onwheel = this.onMapWheelScroll;
      }
    }

    return map;
  }

  fullscreenChangeHandle(fspan) {
    let isFullScreen = false;
    if (fspan.innerHTML === 'fullscreen') {
      fspan.innerHTML = 'fullscreen_exit';
      isFullScreen = true;
    } else { fspan.innerHTML = 'fullscreen'; }

    // update control position
    if (!window.screenTop && !window.screenY) {
       console.log('NOT FULL SCREEN');
      let heightMap = this.heightMapInit;
      if (heightMap <= 0) { heightMap = this.mapDiv.offsetHeight; }
      this.handleFullScreen(isFullScreen, heightMap);
      // console.log('mapHeight = ' + this.mapDiv.offsetHeight);
    } else {
      //  console.log('FULL SCREEN');
       this.handleFullScreen(isFullScreen, this.mapDiv.offsetHeight);
    }
    // console.log('%c fullscreenchange... isFullScreen = ' + isFullScreen + '\n\t, canvas.offsetHeight = ' + this.canvas.offsetHeight
    //     + '\n\t, canvas.clientHeight = ' + this.canvas.clientHeight + '\n\t, mapDiv.offsetHeight = ' + this.mapDiv.offsetHeight
    //     + '\n\t, screen.height = ' + screen.height + '\n\t, map init height = ' + this.heightMapInit, 'color:blue');
  }
  handleFullScreen(isFullScreen, mapHeight) {
    // const mapHeight = this.mapDiv.offsetHeight; // this.canvas.offsetHeight;
    // // if(isFullScreen) mapHeight = window.innerHeight;
    if (this.elementCtrl != null) {
      if (this.type === 0 && this.heightNum < 3 || (this.type === 3 &&  this.heightNum === 1)) {// sc-boundary & selected-asset
        this.mapControlStyle(this.elementCtrl, true, mapHeight);
      } else {
        this.mapControlStyle(this.elementCtrl, false, mapHeight);
      }
    }
    if (this.fullScreenEvent != null && typeof this.fullScreenEvent === 'function') {
      this.fullScreenEvent(mapHeight, isFullScreen);
    }
  }

  addInteractionSnap() {
    this.snap = [];
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (this.layerAssets[i].get('isHeatMap') || this.layerAssets[i].get('layerDisplayOnly') ) { continue; }// ignore heat layer
      const iSnap = new Snap({
        source: this.layerAssets[i].getSource(),
        pixelTolerance: 5
      });
      this.snap.push(iSnap);
      this.map.addInteraction(iSnap);
    }
  }

  removeInteractionSnap() {
    if (!this.snap) { return; }
    for (let i = 0; i < this.snap.length; i++) {
      this.map.removeInteraction(this.snap[i]);
    }
    this.snap = []; // reset
  }

  drawDefaultStyle(drawStart, drawEnd) {
    this.draw = new Draw({
      source: this.source,
      type: this.drawType,
      snapTolerance: 1
    });

    this.map.addInteraction(this.draw);
    if (drawStart) {
      this.draw.on('drawstart', (evt) => {
        if (typeof drawStart === 'function') { drawStart(evt); }
      });
    }
    if (drawEnd) {
      this.draw.on('drawend', (evt) => {
        if (typeof drawEnd === 'function') { drawEnd(evt); }
      });
    }
  }

  drawPrimaryStyle(drawStart, drawEnd) {
    if (this.drawType == null) { this.drawType = 'Point'; }
    let color = '#0099FF'; // default ol blue
    if (this.compActionType === 'primary') { color = 'LimeGreen'; }
    if (this.compActionType === 'secondary') { color = 'black'; }

    // remove old interaction
    if (this.selectPointerMove !== null) {
      this.map.removeInteraction(this.selectPointerMove);
    }
    this.selectPointerMove = new Select({
      condition: condition.pointerMove,
      style: this.selectInteractionStyle.bind(this),
      filter: function(f) {
        if ((f.getGeometry() && f.getGeometry().getType() !== 'Point') ) {
          return true;
        }
      }
    });

    if (this.selectPointerMove !== null) {
      this.map.addInteraction(this.selectPointerMove);
    }


    //
    this.draw = new Draw({
      source: this.source,
      type: this.drawType,
      style: new Style({
        image: new Circle({
          radius: 7,
          fill: new Fill({
            color
          }),
          stroke: new Stroke({
            color: 'white',
            width: 2
          })
        })
      })
    });

    this.map.addInteraction(this.draw);
    if (drawStart) {
      this.draw.on('drawstart', (evt) => {
        if (typeof drawStart === 'function') { drawStart(evt); }
      });
    }
    if (drawEnd) {
      this.draw.on('drawend', (evt) => {
        const fea = evt.feature;
        if (fea) {
          const geom = fea.getGeometry();
          // let type = geom.getType();
          const coord = geom.getCoordinates();
          const coor = proj.transform(coord, this.EPSG, 'EPSG:4326');
          evt.latLng = { lat: parseFloat(coor[1]), lng: parseFloat(coor[0]) };
        }
        if (typeof drawEnd === 'function') { drawEnd(evt); }
      });

    }
  }

  drawCustomStyle(drawStart, drawEnd) {
    if (this.drawType == null) { this.drawType = 'Point'; }
    let color = 'blue';
    if (this.drawingMode === 'multi') {
      color = 'green';
    }
    this.draw = new Draw({
      source: this.source,
      type: this.drawType,
      style: new Style({
        image: new Circle({
          radius: 7,
          fill: new Fill({
            color
          }),
          stroke: new Stroke({
            color: 'white',
            width: 2
          })
        })
      })
    });

    this.map.addInteraction(this.draw);
    if (drawStart) {
      this.draw.on('drawstart', (evt) => {
        let color1 = 'blue';
        if (this.drawingMode === 'multi' &&
          (this.drawType === 'LineString' || this.drawType === 'Polygon' ||
            this.drawType === 'MultiLineString' || this.drawType === 'MultiPolygon')) {
          color1 = 'green';
        }
        const s = new Style({
          stroke: new Stroke({
            color1,
            width: 2
          }),
          image: new Circle({
            radius: 7,
            fill: new Fill({
              color1
            }),
            stroke: new Stroke({
              color: 'white',
              width: 2
            })
          })
        });

        if (evt && evt.feature) {
          evt.feature.setStyle(s);
        }
        if (typeof drawStart === 'function') { drawStart(evt); }
      });
    }
    if (drawEnd) {
      const self = this;
      this.draw.on('drawend', function(evt) {
        const geom = evt.feature.getGeometry();
        const t = geom.getType();
        let color2 = self.color; let fillColor = self.color;
        if (self.drawingMode === 'multi' ) {
          color2 = self.multiColor;
          fillColor = self.multiColor;
        }
        fillColor = self.colorWithAlpha(fillColor, 0.3);
        const s = new Style({
          fill: new Fill({
            color: fillColor
          }),
          stroke: new Stroke({
            color: color2,
            width: 2
          }),
          image: new Circle({
            radius: 7,
            fill: new Fill({
              color: color2
            })
          })
        });

        if (evt && evt.feature) {
          evt.feature.setStyle(s);
        }

        if (typeof drawEnd === 'function') { drawEnd(evt); }
      });
    }
  }

  selectInteractionStyle(feature, resolution) {
    const type = feature.getGeometry().getType();
    let color = 'rgba(0,153,255,1.0)';
    if (this.compActionType === 'primary') {
      color = 'LimeGreen';
    } else if (this.compActionType === 'secondary') { color = 'black'; }
    if (type === 'Point') {
      return feature.get('feaStyle');
    } else if (type === 'MultiPoint') {
      const image = new Circle({
        radius: 7,
        fill: new Fill({
          color: color
        })
      });
      return new Style({
        image
      });
    } else {
      return new Style({
        stroke: new Stroke({
            color: color,
            width: 0,
        }),
        fill: new Fill({
          color: 'rgba(255,255,255,0.5)',
        })
      });
    }
  }

  selectInteraction() {
    // remove old interaction
    if (this.selectPointerMove !== null) {
      this.map.removeInteraction(this.selectPointerMove);
    }
    this.selectPointerMove = new Select({
      condition: condition.pointerMove,
      style: this.selectInteractionStyle.bind(this),
      // filter: function(f) {
      //   if ((f.getGeometry() && f.getGeometry().getType() !== 'Point') ) {
      //     return true;
      //   }
      // }
    });

    if (this.selectPointerMove !== null) {
      this.map.addInteraction(this.selectPointerMove);
      this.selectPointerMove.on('select', this.toolTipOnFeatureHover);
    }
  }

  addInteractionDraw( drawStart, drawEnd) {
    if (this.drawType == null) { this.drawType = 'Point'; }
    if (this.type === 0) {// sc-boundary
      this.drawCustomStyle(drawStart, drawEnd);
    } else if (this.type === 3) {// sc-selected-asset
      this.map.removeInteraction(this.selectPointerMove);
      this.drawPrimaryStyle(drawStart, drawEnd);
    } else {
      this.drawDefaultStyle(drawStart, drawEnd);
    }
  }

  removeInteractionDraw() {
    this.map.removeInteraction(this.draw);
    if (this.type === 3) {// sc-selected-asset
      if (this.compActionType === '') {
        this.selectInteraction();
      }
    }
  }

  addInteraction() {
    this.addInteractionDraw({}, {});

    this.vector.getSource().on('addfeature', event => {// finish drawing
      if (this.setDirtyFunction && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
        // scope.$apply();
      }
    });
  }

  btnAddEvent(btn) {
    btn.onmouseover = () => {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'lightgrey';
    };
    btn.onmouseout = () => {
      if (btn.style.backgroundColor === 'grey') { return; }
      btn.style.backgroundColor = 'white';
    };
  }

  deselectAllControlBtn(currentBtnId) {
    for (let i = 0; i < this.controlBtns.length; i++) {
      if (this.controlBtns[i].id === currentBtnId) { continue; }
      this.controlBtns[i].style.backgroundColor = 'white';
    }
  }

  modeAction(e) {
    if (this.drawingMode === 'single') {
      if (e && e.currentTarget && e.currentTarget.title ) {
        e.currentTarget.title = 'Multi mode';
      }
      this.drawingMode = 'multi';
      this.modeLabel.innerHTML = 'layers';
    } else {
      if (e && e.currentTarget && e.currentTarget.title ) {
        e.currentTarget.title = 'Single mode';
      }
      this.drawingMode = 'single';
      this.modeLabel.innerHTML = 'layers_clear';
    }
    this.actionType = 'mode';

    this.deselectAllControlBtn(e.currentTarget.id);

    this.map.removeInteraction(this.draw);
    this.map.removeInteraction(this.modify);
  }

  selectAction(e) {

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.map.removeInteraction(this.draw);
      this.actionType = '';
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'select';
      this.map.removeInteraction(this.draw);
      this.map.addInteraction(this.modify);
    }
  }

  polygonAction(e) {

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
      this.drawType = '';
      this.map.removeInteraction(this.modify);
      this.map.removeInteraction(this.draw);
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'edit';
      this.drawType = (this.drawingMode === 'single' ? 'Polygon' : 'MultiPolygon');
      this.map.removeInteraction(this.modify);
      this.map.removeInteraction(this.draw);
      this.addInteraction();
    }
  }

  deleteAction(e) {

    this.map.removeInteraction(this.modify);
    this.map.removeInteraction(this.draw);

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.actionType = '';
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'delete';
    }

  }

  pointAction(e) {

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.map.removeInteraction(this.draw);
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'edit';
      this.drawType = (this.drawingMode === 'single' ? 'Point' : 'MultiPoint');
      this.map.removeInteraction(this.modify);
      this.map.removeInteraction(this.draw);
      this.addInteraction();
    }
  }

  lineAction(e) {
    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') {
      e.currentTarget.style.backgroundColor = 'white';
      this.map.removeInteraction(this.draw);
    } else {
      e.currentTarget.style.backgroundColor = 'grey';
      this.actionType = 'edit';
      this.drawType = (this.drawingMode === 'single' ? 'LineString' : 'MultiLineString');
      this.map.removeInteraction(this.modify);
      this.map.removeInteraction(this.draw);
      this.addInteraction();
    }
  }

  locationAction(e) {
    this.actionType = 'location';
    if (this.getLocationFn && typeof this.getLocationFn === 'function') {
      this.getLocationFn();
    }
    // this.getLocation();

    this.deselectAllControlBtn(e.currentTarget.id);
    if (e.currentTarget.style.backgroundColor === 'grey') { e.currentTarget.style.backgroundColor = 'white';
    } else { e.currentTarget.style.backgroundColor = 'grey'; }
  }

  getLocation() {
    // NOTE : no need here, will move to component ifself
    // if(scope.disabled) return;
    // scope.isVisible = "true";
    // if (navigator.geolocation) {
    //     navigator.geolocation.getCurrentPosition(scope.showPosition);
    // } else {
    //     scope.error = "Geolocation is not supported by this browser.";
    // }
  }

  // clone from sclMapViews.addRadioButton and have modify
  addRadioButton(document, element, layers, compId) {
    layers.forEach((layer, i) => {
      const title = layer.get('title');
      const radio = sclMapViews.createRadio(document, compId + title, layer.getVisible(), compId);
      radio.onclick = () => {
        layers.forEach((layer1, j) => {
          let value = layer1.get('title');
          if (!value || value === 'Vector') {
            return;
          }
          const newTil = compId + title;
          value = compId + value;
          if (value === newTil) {
            layer1.setVisible(true);
            if (layer1 instanceof Group) {
              layer1.getLayers().forEach((sublayer, k) => {
                sublayer.setVisible(true);
              });
            }
          } else {
            layer1.setVisible(false);
          }
        });
      };


      element.appendChild(radio);
      // label for this radio
      const label =  sclMapViews.createLabel(document, compId + title, '');
      // sLabel is a span inside label
      const sLabel = document.createElement('span');
      sLabel.innerHTML = title;
      sLabel.style.verticalAlign = '-webkit-baseline-middle';
      sLabel.style.color = 'black';
      label.appendChild(sLabel);
      element.appendChild(label);
    });
  }

  addMapViewControl(element, mapViewLayers, compId, layerIds) {
    const elementMapView = document.createElement('div');
    elementMapView.className = 'select-action ol-control custom-control';
    elementMapView.style.top = '10px'; // map view control always on top of map
    if (typeof mapViewLayers !== 'undefined' || mapViewLayers !== null) {
      const radioElement = document.createElement('div');
      radioElement.className = 'radio-group';
      this.addRadioButton(document, radioElement, mapViewLayers, compId);
      elementMapView.appendChild(radioElement);
      mapViewLayers.forEach((layer, i) => {
        const title = compId + layer.get('title');
        layerIds.push(title);
      });
    }

    element.append(elementMapView);
  }

  addControlDraw(compId, pOptions, cb) {
    const layerIds = [];
    const self = this;
    const ActionControl = function(ctrlOptions) {
      const options = ctrlOptions || {};

      const element = document.createElement('div');

      if (pOptions != null) {
        self.addMapViewControl(element, pOptions.mapViewLayers, compId, layerIds);
      }

      const modeBtn = sclMapViews.createUIButton(document, self.modeAction.bind(self), 'ol-has-tooltip',
        (self.drawingMode === 'single' ? 'Single mode' : 'Multi mode'), null );
      self.modeLabel = document.createElement('i');
      self.modeLabel.setAttribute('class', 'material-icons');
      self.modeLabel.innerHTML = (self.drawingMode === 'single' ? 'layers_clear' : 'layers') ;
      modeBtn.appendChild(self.modeLabel);
      modeBtn.id = compId + 'Mode';
      layerIds.push(modeBtn.id);


      const selectBtn = sclMapViews.createUIButton(document, self.selectAction.bind(self), 'ol-has-tooltip',
        'Select', null);

      let iSpan = document.createElement('i');
      iSpan.setAttribute('class', 'material-icons');
      iSpan.innerHTML = 'create';
      selectBtn.appendChild(iSpan);
      selectBtn.id = compId + 'Select';
      layerIds.push(selectBtn.id);

      const pointBtn = sclMapViews.createUIButton(document, self.pointAction.bind(self), 'ol-has-tooltip',
        'Point', null);
      iSpan = document.createElement('i');
      iSpan.setAttribute('class', 'material-icons');
      iSpan.innerHTML = 'pin_drop';
      pointBtn.appendChild(iSpan);
      pointBtn.id = compId + 'Point';
      layerIds.push(pointBtn.id);

      const lineBtn = sclMapViews.createUIButton(document, self.lineAction.bind(self), 'ol-has-tooltip',
        'Line', null);
      iSpan = document.createElement('i');
      iSpan.setAttribute('class', 'material-icons');
      iSpan.innerHTML = 'linear_scale';
      lineBtn.appendChild(iSpan);
      lineBtn.id = compId + 'Line';
      layerIds.push(lineBtn.id);

      const boundaryBtn = sclMapViews.createUIButton(document, self.polygonAction.bind(self), 'ol-has-tooltip',
        'Polygon', null);
      iSpan = document.createElement('i');
      iSpan.setAttribute('class', 'material-icons');
      iSpan.innerHTML = 'turned_in_not';
      boundaryBtn.appendChild(iSpan);
      boundaryBtn.id = compId + 'Polygon';
      layerIds.push(boundaryBtn.id);

      const locationBtn = sclMapViews.createUIButton(document, self.locationAction.bind(self), 'ol-has-tooltip',
        'Current Location', null);
      iSpan = document.createElement('i');
      iSpan.setAttribute('class', 'material-icons');
      iSpan.innerHTML = 'my_location';
      locationBtn.appendChild(iSpan);
      locationBtn.id = compId + 'CurrentLocation';
      layerIds.push(locationBtn.id);

      const deleteBtn = sclMapViews.createUIButton(document, self.deleteAction.bind(self), 'ol-has-tooltip',
        'Delete', null);
      iSpan = document.createElement('i');
      iSpan.setAttribute('class', 'material-icons');
      iSpan.innerHTML = 'delete';
      deleteBtn.appendChild(iSpan);
      deleteBtn.id = compId + 'Delete';
      layerIds.push(deleteBtn.id);


      const elementCtrl = document.createElement('div');
      elementCtrl.className = 'select-action ol-control custom-control';

      elementCtrl.appendChild(modeBtn);
      elementCtrl.appendChild(selectBtn);
      elementCtrl.appendChild(pointBtn);
      elementCtrl.appendChild(lineBtn);
      elementCtrl.appendChild(boundaryBtn);
      elementCtrl.appendChild(locationBtn);
      elementCtrl.appendChild(deleteBtn);
      // elementCtrl.appendChild(propertiesBtn);

      self.elementCtrl = elementCtrl;

      self.controlBtns = [modeBtn, selectBtn, pointBtn, lineBtn, boundaryBtn, locationBtn, deleteBtn];
      self.btnAddEvent(modeBtn); self.btnAddEvent(selectBtn); self.btnAddEvent(pointBtn);
      self.btnAddEvent(lineBtn); self.btnAddEvent(boundaryBtn); self.btnAddEvent(locationBtn);
      self.btnAddEvent(deleteBtn);

      element.appendChild(elementCtrl);

      Control.call(this, {
        element,
        target: options.target
      });
    };
    olInherits(ActionControl, Control);
    this.map.addControl(new ActionControl({}));

    cb(layerIds);
  }

  testRedraw(e) {
    console.log('click btn, id = ' + e.currentTarget.id);
    const idx = parseInt(e.currentTarget.id, 10);
    this.clearAllFeaturesLayer(idx);
    setTimeout(() => {
      if (idx in this.assetOfLayers) {
        for (let i = 0; i < this.assetOfLayers[idx].length; i++) {
          if (!this.layerAssets[idx].getSource()) { continue; }
          this.layerAssets[idx].getSource().addFeature(this.assetOfLayers[idx][i]);
          console.log('redraw feature of layerIdx = ' + idx);
        }
      }
    }, 1000);

  }

  addTestBtn(element) {
    const testDiv = document.createElement('div');
    testDiv.className = 'select-action ol-control custom-control';
    let idx = 1;
    for (let i = 0; i < this.layersRedrawCount; i++) {
      const testBtn = sclMapViews.createUIButton(document, this.testRedraw.bind(this), 'ol-has-tooltip', (idx + ''), null );
      testBtn.setAttribute('id', idx);
      const iSpan = document.createElement('i');
      iSpan.innerHTML = idx + '';
      testBtn.appendChild(iSpan);

      testDiv.appendChild(testBtn);
      idx++;
    }
    this.testDiv = testDiv;
    element.appendChild(testDiv);
  }

  addControl(ActionControl, element, options) {
    if (this.layersRedraw) {
      this.addTestBtn(element);
    }
    Control.call(ActionControl, {
      element,
      target: options.target
    });
  }

  setupControl(ActionControl) {
    olInherits(ActionControl, Control);
  }

  mapClickEvent(cb) {
    this.map.on('click', (evt) => {
      const coor = proj.transform(evt.coordinate, this.EPSG, 'EPSG:4326');
      evt.latLng = { lat: parseFloat(coor[1]), lng: parseFloat(coor[0])};
      const featureOnClick = this.map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
        const fs = feature.get('features');
        if (fs) {
          return fs;
        }
        return feature;
      });
      if (featureOnClick) {
        if (Array.isArray(featureOnClick) && featureOnClick.length > 0) {
          if (this.clusterClick && typeof this.clusterClick === 'function') {
            this.clusterClick(featureOnClick, evt.pixel);
          }
        } else {
          if (cb && typeof cb === 'function') {
            cb(evt);
          }
        }
      } else {
        if (cb && typeof cb === 'function') {
          cb(evt);
        }
      }
      // if (cb && typeof cb === 'function') {
      //   cb(evt);
      // }
    });
  }
  mapPointerMoveEvent(cb) {
    this.map.on('pointermove', (evt) => {
      if (cb && typeof cb === 'function') {
        cb(evt);
      }
    });
  }

  getPointFeature(location , image, name, id, relatedAsset, color, layerDisplayOnly, tooltip, anchor, type, layerName) {
    const graphPoint = new Feature(new Point(location));
    if (arguments.length === 2) {
      graphPoint.setProperties({
        icon: image
      });
    } else {
      const properties: any = {
        icon : image,
        name,
        id
      };
      if (color) {properties.color = color; }
      if (tooltip) {properties.tooltip = tooltip; }
      if (layerDisplayOnly) {properties.layerDisplayOnly = layerDisplayOnly; }
      if (type) {properties.type = type; }
      if (anchor) {properties.anchor = anchor; }
      if (layerName) {properties.layerName = layerName; }
      if (relatedAsset) {
        for (const field in relatedAsset) {
          if (relatedAsset.hasOwnProperty(field)) {
            const value = relatedAsset[field];
            properties[field] = value;
          }
        }
      }
      graphPoint.setProperties(properties);
    }
    return graphPoint;
  }

  updateLocation(lat, lon, id, image, name, proId, isMapClick) {
    // let location = proj.transform([lon, lat], 'EPSG:4326', 'EPSG:3857');
    const location = proj.transform([lon, lat], 'EPSG:4326', this.EPSG);
    if (isMapClick === false) {
      this.view.setCenter(location);
      this.view.setResolution(1);
    }

    if (proId != null && this.marker != null && this.marker.getId() === proId) {
      // let checkFeature = this.getFeatureById(proId);//13835 // this.source.getFeatureById(proId);
      // if(checkFeature){
      //    this.removeFeature(checkFeature);//13835 //this.source.removeFeature(checkFeature);
      //    this.removeFeature(this.marker);
      //    this.marker = null;
      // }
      this.marker.getGeometry().setCoordinates(location);
    } else {
      if (!image) { image = sclMapConstant.MAP_MARKER; }
      this.marker = this.getPointFeature(location, image, name, proId, null, null, null, null, null, null, null);

      this.marker.setId(proId);

      // this.source.addFeature(this.marker);//13835
      this.marker.setStyle(this.styleAsset(this.marker, null)); // 15886: set static style instead of using style from layer to prevent high CPU
      this.layerAssets[this.layerIndexAddress].getSource().addFeature(this.marker);
    }
  }

  removeLocation(feature) {
    if (feature && this.layerAssets[this.layerIndexAddress] && this.layerAssets[this.layerIndexAddress].getSource()) {
      this.layerAssets[this.layerIndexAddress].getSource().removeFeature(feature);
    }
    this.marker = null;
  }

  zoomToLocation(lat, lon) {
    const location = proj.transform([lon, lat], 'EPSG:4326', this.EPSG);
    this.view.setCenter(location);
    this.view.setResolution(1);

  }

  zoomToValue(zoomValue) {
    // if (!zoomValue && this.defaultZoom ) { zoomValue = this.defaultZoom; }// 14707
    if (zoomValue) {
      this.view.setZoom(zoomValue);
    }

  }
  // 14781
  centerDefault() {
    this.zoomToLocation(this.defaultLat, this.defaultLon);
  }
  // 14781
  fitLayers(layersIndexFit, hasDefaultCoord) {
    const extent = olExtent.createEmpty();
    if (hasDefaultCoord) {
      const location = proj.transform([this.defaultLon, this.defaultLat], 'EPSG:4326', this.EPSG);
      const fExtent = [location[0], location[1], location[0], location[1]];
      olExtent.extend(extent, fExtent);
    }
    let padding = 0; // 15141: #4
    for (let i = 0; i < layersIndexFit.length; i++) {
        const idx = layersIndexFit[i];
        if (!this.layerAssets[idx].getSource()) { continue; }
        const fs = this.layerAssets[idx].getSource().getFeatures();
        if (fs == null || fs.length === 0) { continue; }

        this.layerAssets[idx].getSource().getFeatures().forEach(function(feature) {
          const fExt = feature.getGeometry().getExtent();
          olExtent.extend(extent, fExt);
          if (feature.getGeometry().getType() === 'Point') {
            padding = 32; // 15141: #4
          }
        }.bind(this));
    }
    if (extent !== null && extent.length === 4 && isFinite(extent[0]) && isFinite(extent[1])
     && isFinite(extent[2]) && isFinite(extent[3]) ) {
      this.view.fit(extent, {padding: [padding, padding, padding, padding]}); // 15141: #4
    }
  }

  createMarkerAsset(lat, lon, id, image, name , type) {
    const location = proj.transform([lon, lat], 'EPSG:4326', this.EPSG);


    const f = this.getPointFeature(location, image, name, id, null, null, null, null, null, null, null);
    if (type) { f.set('assetType', type); }
    f.setId(id);

    // this.source.addFeature(f);//13835
    if (type === sclMapConstant.ASSET_PRIMARY_TYPE) {
      f.setStyle(this.stylePrimaryAssetFunc(f, null));
      this.layerAssets[this.layerIndexPrimary].getSource().addFeature(f);
    } else if (type === sclMapConstant.ASSET_SECONDARY_TYPE) {
      f.setStyle(this.styleSecondaryAssetFunc(f, null));
      this.layerAssets[this.layerIndexSecondary].getSource().addFeature(f);
    } else { 
      f.setStyle(this.styleAsset(f, null));
      this.layerAssets[this.layerIndexAddress].getSource().addFeature(f); 
    }

    return location;
  }

  getGEOJSON(cb) {
    const features = this.vector.getSource().getFeatures();
    const format = new GeoJSON();
    if (this.type === 0) {// sc-boundary
      const fp = 'EPSG:4326';
      const data = format.writeFeaturesObject(features, {featureProjection: this.EPSG, dataProjection: fp });
      const finalData = { type: 'FeatureCollection', features: [] };
      const multiPoint = { type: 'Feature', properties: null, geometry: { type: 'MultiPoint', coordinates: []}};
      const multiPolygon = {type: 'Feature', properties: null, geometry: {type: 'MultiPolygon', coordinates: []}};
      const multiLineString = {type: 'Feature', properties: null, geometry: {type: 'MultiLineString', coordinates: []}};

      for (let i = 0; i < data.features.length; i++) {
        if (data.features[i].geometry.type === 'MultiPoint') {
          for (let j = 0; j < data.features[i].geometry.coordinates.length; j++) {
            multiPoint.geometry.coordinates.push(data.features[i].geometry.coordinates[j]);
          }
        } else if (data.features[i].geometry.type === 'MultiPolygon') {
          for (let j = 0; j < data.features[i].geometry.coordinates.length; j++) {
            multiPolygon.geometry.coordinates.push(data.features[i].geometry.coordinates[j]);
          }
        } else if (data.features[i].geometry.type === 'MultiLineString') {
          for (let j = 0; j < data.features[i].geometry.coordinates.length; j++) {
            multiLineString.geometry.coordinates.push(data.features[i].geometry.coordinates[j]);
          }
        } else {
          finalData.features.push(data.features[i]);
        }
      }
      if (multiPoint.geometry.coordinates.length > 0) {
        finalData.features.push(multiPoint);
      }
      if (multiPolygon.geometry.coordinates.length > 0) {
        finalData.features.push(multiPolygon);
      }
      if (multiLineString.geometry.coordinates.length > 0) {
        finalData.features.push(multiLineString);
      }
      if (cb && typeof cb === 'function') {
        cb(finalData);
      }
    } else {
      const data = format.writeFeaturesObject(features);
      if (cb && typeof cb === 'function') {
        cb(data);
      }
    }
  }

  transformEPSG(long, lat, from, to) {
    const location = proj.transform([parseFloat(long), parseFloat(lat)], from, to);
    return location;
  }

  checkMapEmpty(pCanvas) {
    if (pCanvas == null) { return; }
    try {
      const ctx = pCanvas.getContext('2d');
      const imageData = ctx.getImageData(0, 0, pCanvas.width, pCanvas.height);
      const data = imageData.data;
      const imageDataLength = data.length;

      let totalAlpha = 0; let countTransparent = 0;
      for (let i = 3; i < imageDataLength; i += 4) {
        totalAlpha++;
        if (data[i] === 0) { countTransparent++; }
      }
      if (totalAlpha === countTransparent && totalAlpha > 0) {
        // console.log('%c map is empty', 'color:green');
        // if(NotificationService) NotificationService.warning('The map is empty !');
        if (this.fromFitData) {
          console.log('We have no map tiles to display.  '
          + 'Your map is centered at LAT, LONG which may not be with in your map tile service.'
          + '  Please check that location and the data you are trying to display.');
        }
      }
      this.fromFitData = false;
    } catch (err) {

    }

  }

  fit(ConfigService, maxZoom, initialZoomChange, isCheckEmpty) {
    // console.log('OL, fit');

    if (this.type !== 1) {
      let maxZoom1 = 15;
      if (maxZoom) { maxZoom1 = maxZoom;
      } else {
        if (ConfigService.clientConfig().maxZoomLevel) {
          maxZoom1 = ConfigService.clientConfig().maxZoomLevel;
        }
      }
      const featuresExtent = this.source.getExtent() ;
      if (featuresExtent != null && featuresExtent.length === 4 && isFinite(featuresExtent[0]) && isFinite(featuresExtent[1])
        && isFinite(featuresExtent[2]) && isFinite(featuresExtent[3]) ) {
        this.view.fit(featuresExtent, {size: this.map.getSize(), maxZoom1});
      }
      if (this.layerAssets != null && this.layerAssets.length > 0) {
        for (let i = 0; i < this.layerAssets.length; i++) {
          const extent = this.layerAssets[i].getSource().getExtent();
          if (extent != null && extent.length === 4 && isFinite(extent[0]) && isFinite(extent[1]) && isFinite(extent[2]) &&
            isFinite(extent[3]) ) {
            this.view.fit(extent, this.map.getSize());
          }
        }
      }
    } else {
      const extent = olExtent.createEmpty();
      if (this.layerAssets != null && this.layerAssets.length > 0) {
        for (let i = 0; i < this.layerAssets.length; i++) {
          if (!this.layerAssets[i].getSource()) { continue; }
          const fs = this.layerAssets[i].getSource().getFeatures();
          if (fs == null || fs.length === 0) { continue; }

          this.layerAssets[i].getSource().getFeatures().forEach(function(feature) {
            try {
              olExtent.extend(extent, feature.getGeometry().getExtent());
            } catch (err) {
              console.log(err);
            }
          });

        }
      }
      if (extent != null && extent.length === 4 && isFinite(extent[0]) && isFinite(extent[1]) && isFinite(extent[2]) &&
        isFinite(extent[3]) ) {
        this.view.fit(extent);
      }

    }

    if (initialZoomChange != null && initialZoomChange !== 0) {
      let currentZoom = this.view.getZoom();
      currentZoom += initialZoomChange;
      this.view.setZoom(currentZoom);
    }

    // 13885
    if (this.type === 1 && this.view.getZoom() > 12) {
      this.view.setZoom(12);
    }

    if (isCheckEmpty === undefined || isCheckEmpty === null || isCheckEmpty === true) { 
      // this.checkMapEmpty(this.canvas); 
      this.fromFitData = true;
    }
    this.clampZoomFloor();
  }

  fitCoords(coords) {
    // calculate bounds base on collection of coordinates
    if (!coords || coords.length === 0) { return; }
    this.bounds = olExtent.createEmpty();
    this.fitCoordCount = coords.length;
    for (let i = 0; i < coords.length; i++) {
      const iCoord = proj.transform(coords[i], 'EPSG:4326', this.EPSG) ;
      const geom = new Point(iCoord);
      olExtent.extend(this.bounds, geom.getExtent());
    }
    this.view.fit(this.bounds);

    if (coords.length === 1) {
      let currentZoom = this.view.getZoom();
      currentZoom = currentZoom - 2;
      if (currentZoom < 0) { currentZoom = 1; }
      this.view.setZoom(currentZoom);
    }
    // console.log('%c fitCoord, mapZoom = ' + this.view.getZoom(), 'color:blue');
    this.clampZoomFloor();
  }

  mapReadOnly(isReadOnly) {
    if (isReadOnly) {
      this.map.removeInteraction(this.modify);
      this.map.removeInteraction(this.draw);
    } else {
      if (this.actionType) {
        if (this.actionType === 'select') {
          this.map.addInteraction(this.modify);
        } else if (this.actionType !== 'delete') {
          this.addInteraction();
        }
      }
    }
  }

  getAllFeatures() {
    let features = [];
    if (this.vector.getSource()) { features = this.vector.getSource().getFeatures(); }
    if (this.layerAssets != null && this.layerAssets.length > 0) {
      for (let i = 0; i < this.layerAssets.length; i++) {
        if (!this.layerAssets[i].getSource()) { continue; }
        const fs = this.layerAssets[i].getSource().getFeatures();
        if (fs != null && fs.length > 0) {
          fs.forEach(function(f) {
            features.push(f);
          });
        }
      }
    }

    return features;
  }

  getFeaturesFromMap(features, pixel, type, assetSelectionsAvailable) {
    const existedFeatures = [];
    const self = this;
    this.map.forEachFeatureAtPixel(pixel,
      function(feature, layer) {
        if (feature && layer) {
          if (layer.get('isCluster')) {
            const lstFeature = feature.get('features');
            for (let i = 0; i < lstFeature.length; i++) {
              const result = self.getAFeatureFromMap(lstFeature[i], features, type, assetSelectionsAvailable);
              if (result.f) { features.push(result.f); }
              if (result.existedFeature) { existedFeatures.push(result.existedFeature); }
            }
          }
          else {
            const result = self.getAFeatureFromMap(feature, features, type, assetSelectionsAvailable);  
            if (result.f) { features.push(result.f); }
            if (result.existedFeature) { existedFeatures.push(result.existedFeature); }
          }
        }
      });
    return existedFeatures;
  }
  getAFeatureFromMap(feature, features, type, assetSelectionsAvailable) {
    let existedFeature, f;
    if (!feature.getProperties() || feature.getProperties().id === undefined) { 
      return {existedFeature, feature}; 
    }
    const p = feature.getProperties();
    // if(p.layerDisplayOnly) return;
    if ( assetSelectionsAvailable == null && p.layerDisplayOnly) { 
      return {existedFeature, feature};
    } else {
      const iAssetSelectionsAvailable = assetSelectionsAvailable[((p.zIndex - 1) < 0 ? 0 : (p.zIndex - 1))];
      if ( iAssetSelectionsAvailable != null && iAssetSelectionsAvailable.indexOf(type) < 0 ) {
        let sType = type;
        if (type != null && type.trim().length > 0) {
          sType = type.charAt(0).toUpperCase() + ( (type != null && type.trim().length > 1 ) ? type.slice(1) : '' ); }
        console.log('sc-selected-asset: The assetSelectiosAvailable field is not set to allow ' + sType +
          ' selections for this layer');
        return {existedFeature, feature};
      }
    }
    if (p.id === 'address') { return {existedFeature, feature}; }
    if ( (type === 'primary' && p.id && p.id.indexOf('_secondary') > -1 ) || (type === 'secondary' &&
      p.id && p.id.indexOf('_primary') > -1 ) ) { return {existedFeature, feature}; }
    if (p.assetType !== type) {
      let isExist = false;
      for (let i = 0; i < features.length; i++) {
        if (features[i].getProperties().name === p.name) {
          isExist = true;
          break;
        }
      }
      if (!isExist) { f = feature; }
    } else {
      existedFeature = feature;
    }
    return {existedFeature, f};
  }

  getAssetProperties(feature, relatedFields, coordinates, typeAsset, typeSelection) {
    let name = '';
    let id = '';
    if (feature.getProperties()) {
      name = feature.getProperties().name;
      id = feature.getProperties().id;
    }

    const propertiesLinkAsset = {
      documentId: id,
      name
    };
    const asset: any = {
      type: 'Feature',
      properties : {
        type: typeAsset,
        linkAssets: []
      }
    };
    if (!typeSelection || typeSelection === 'featureCollection') {
      asset.geometry = {
        type : 'Point',
        coordinates
      };
    } else if (typeSelection !== 'undefined' && typeSelection === 'Asset') {
      const t = feature.getGeometry().getType();
      asset.geometry = {
        type : t,
        coordinates
      };
    }

    if (!id) {
      return '';
    }
    if (relatedFields) {
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const value = feature.getProperties()[field];
          if (value) {
            propertiesLinkAsset[field] = value;
          }
        }
      }
    }
    asset.properties.linkAssets.push(propertiesLinkAsset);
    return asset;
  }

  removeUnselectedAssetItem(existAsset, assets, type) {
    if (existAsset) {
      let isExist = false;
      let idExistAsset = existAsset.properties.linkAssets[0].documentId;
      if (idExistAsset && idExistAsset.indexOf('_') > -1) { idExistAsset = idExistAsset.split('_')[0]; }
      for (let j = 0; j < assets.length; j++) {
        const item = assets[j];
        let idItem = item.properties.linkAssets[0].documentId;
        if (idItem == null) { continue; }
        if (idItem.indexOf('_') > -1) { idItem = idItem.split('_')[0]; }
        const id = item.properties.linkAssets[0].documentId + '_' + type;
        if (idItem === idExistAsset) {
          assets.splice(j, 1);
          isExist = true;
        }
      }
      const len = this.selectedAssets.length;
      for (let i = len - 1; i > -1; i--) {
        let iId = this.selectedAssets[i].getId();
        if (iId && iId.indexOf('_') > -1) { iId = iId.split('_')[0]; }
        if (iId === idExistAsset) {
          const f = this.selectedAssets[i];
          if (f == null || f.getId() == null) { continue; }
          if (type === 'primary') {
            const source = this.layerAssets[this.layerIndexPrimary].getSource();
            const fea = source.getFeatureById(f.getId());
            if (fea && source) {
              source.removeFeature(fea);
              this.selectedAssets.splice(i, 1);
            }
          } else {
            const source = this.layerAssets[this.layerIndexSecondary].getSource();
            const fea = source.getFeatureById(f.getId());
            if (fea && source) {
              source.removeFeature(fea);
              this.selectedAssets.splice(i, 1);
            }
          }

          isExist = true;
        }
      }
      return isExist;
    }
    return false;
  }

  parseAssetsFromFeatures(features, assetField, coor, typeAsset, mode) {
    if (mode === 'Asset') {
      const asset = this.getAssetProperties(features, assetField.relatedFields, coor, typeAsset, mode);
      return asset;
    } else {
      const assets = [];
      for (let i = 0; i < features.length; i++) {
        const asset = this.getAssetProperties(features[i], assetField.relatedFields, coor[i], typeAsset, null);
        if (!asset) {return; }
        assets.push(asset);
      }
      return assets;
    }
  }

  getAllFeaturesSelected() {
    if (this.selectMultiple) {
      return this.selectMultiple.getFeatures();
    } else { return []; }
  }

  addInteractionSelect(currentSelected) {
    if (this.selectMultiple) {
      this.map.addInteraction(this.selectMultiple);
    }
  }

  removeInteractionSelect() {
    if (this.selectMultiple) {
      this.map.removeInteraction(this.selectMultiple);
    }
  }

  showLayer(options) {
    if (options.isShow) {
      this.layerAssets[options.layerIndex].setVisible(true);
    } else {
      this.layerAssets[options.layerIndex].setVisible(false);
    }
  }

  activeInteractionSelect(isActive) {
    if (this.selectMultiple) {
      this.selectMultiple.setActive(isActive);
    }
  }

  drawActionDelete(evt) {
    this.map.forEachFeatureAtPixel(evt.pixel, (f, l) => {
      this.vector.getSource().removeFeature(f);
      if (this.type === 0 && this.setDirtyFunction && typeof this.setDirtyFunction === 'function' ) {
        this.setDirtyFunction();
        // scope.$apply();
      }
    });
  }

  drawActionProperties(evt) {
    const feature = this.map.forEachFeatureAtPixel(evt.pixel,
      function(feature1, layer) {
        return feature1;
      });
  }

  sclAssetLayersGetPointFeature(location , image, name, id, relatedAsset, color, layerDisplayOnly, tooltip, anchor, type, layerName, url) {
    let graphPoint;
    if (type === 'MultiPoint') { graphPoint = new Feature(new MultiPoint(location));
    } else { graphPoint = new Feature(new Point(location)); }
    const properties: any = {
      icon : image,
      name,
      id
    };
    if (color) {properties.color = color; }
    if (tooltip) {properties.tooltip = tooltip; }
    if (layerDisplayOnly) {properties.layerDisplayOnly = layerDisplayOnly; }
    if (type) {properties.type = type; }
    if (anchor) {properties.anchor = anchor; }
    if (layerName) {properties.layerName = layerName; }
    if (url) {properties.url = url; }
    if (relatedAsset) {
      for (const field in relatedAsset) {
        if (relatedAsset.hasOwnProperty(field)) {
          const value = relatedAsset[field];
          properties[field] = value;
        }
      }
    }

    graphPoint.setProperties(properties);

    return graphPoint;
  }

  parseToLine(coor, id, toEPSG) {

    const feature = new Feature(new LineString(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }

  parseToMultiLine(coor, id, toEPSG) {
    const feature = new Feature(new MultiLineString(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }

  parseToPolygon(coor, id, toEPSG) {
    const feature = new Feature(new Polygon(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }

  parseToMultiPolygon(coor, id, toEPSG) {
    const feature = new Feature(new MultiPolygon(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }

  parseToPoint(coor, id, toEPSG) {
    const feature = new Feature(new Point(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }

  parseToMultiPoint(coor, id, toEPSG) {
    const feature = new Feature(new MultiPoint(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }

  sclAssetLayersCreateFeatureByType(coordinates, type, EPSG, id) {
    let feature;
    if (type === 'Point') {
      feature = this.parseToPoint(coordinates, id, EPSG);
    } else if (type === 'MultiPoint') {
      feature = this.parseToMultiPoint(coordinates, id, EPSG);
    } else if (type === 'LineString') {
      feature = this.parseToLine(coordinates, id, EPSG);
    } else if (type === 'MultiLineString') {
      feature = this.parseToMultiLine(coordinates, id, EPSG);
    } else if (type === 'Polygon') {
      feature = this.parseToPolygon(coordinates, id, EPSG);
    } else if (type === 'MultiPolygon') {
      feature = this.parseToMultiPolygon(coordinates, id, EPSG);
    }

    return feature;
  }

  traverseCoor(coor, obj) {
    if (Array.isArray(coor)) {
      for (let i = 0; i < coor.length; i++) {
        if (Array.isArray(coor[i])) {
          this.traverseCoor(coor[i], obj);
        } else {
          if (isNaN(coor[i]) ) { obj.hasNaN = true; } else { coor[i] = Number(coor[i]); }
        }
      }
    }
  }

  createFeaturePoint(coord, type, options) {
    let feature;
    const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
    const url = (options.url ? options.url : '');
    const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
    const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');

    const lon = Number(coord[0]); const lat = Number(coord[1]) ;
    if (isNaN(lon) || isNaN(lat)) { return null; }

    const location = proj.transform([lon, lat], 'EPSG:4326', options.EPSG);

    let point = sclMapConstant.MAP_MARKER;
    if (options.point) { point = options.point; }
    if (options.imageFileNo) {
      if (options.imageFileNo === sclMapConstant.MAP_MARKER
        || options.imageFileNo === sclMapConstant.MAP_PRIMARY_ASSET
        || options.imageFileNo === sclMapConstant.MAP_SECONDARY_ASSET) {
        point = options.imageFileNo;
      } else { 
        point = options.imageFileNo; // 15783 '/api/getFile/' + options.imageFileNo; 
      }
    }
    if (options.image) { point = options.image; }
    feature = this.sclAssetLayersGetPointFeature(location, point, options.name, options.id, relatedAssets,
      options.color, options.layerDisplayOnly,
      options.tooltip, options.anchor, '', '', url);
    const p = feature.getProperties();
    p.isCluster = true;
    if (options.label != null) {
      p.label = options.label;
    }
    if (options.rotation) { p.rotation = options.rotation; }
    if (options.scale) {p.scale = options.scale; }
    feature.setProperties(p);
    feature.setId(options.id);
    return feature;
  }

  createFeatureByType(coord, type, options) {
    let feature;
    const relatedAssets = (options.relatedAsset ? options.relatedAsset : '');
    const url = (options.url ? options.url : '');
    const primaryMultiPopup = (options.primaryMultiPopup ? options.primaryMultiPopup : '');
    const secondaryMultiPopup = (options.secondaryMultiPopup ? options.secondaryMultiPopup : '');

    if (type === 'Point') {
      feature = this.createFeaturePoint(coord, type, options);
    } else {
      if (options.layerType === 'cluster') {
        type = 'Point';
        const centerPoint = options.centerPoint;
        delete options.centerPoint;
        feature = this.createFeaturePoint(centerPoint, type, options);
      } else {
        const hasNaN = false;
        const obj = { hasNaN};
        this.traverseCoor(coord, obj);
        if (obj.hasNaN) { return null; }
  
        feature = this.sclAssetLayersCreateFeatureByType(coord, type, options.EPSG, options.id);
  
        if (feature == null) { return null; }
  
        let color = 'purple';
        // Changed to use color setup in selected asset for handlebars
        if (options.color) {color = options.color; }
        const properties: any = sclAssetLayers.createLineProperties(options.layer, options.name, color,
          options.id, options.tooltip, primaryMultiPopup, secondaryMultiPopup,
          options.layerDisplayOnly, relatedAssets, url);
        if (options.label != null) { properties.label = options.label; }
        
        feature.setProperties(properties);
      }
      
    }
    return feature;
  }

  setFeatureProperties(feature, properties) {
    for (const p in properties) {
      if (properties.hasOwnProperty(p)) {
        feature.set(p, properties[p]);
      }
    }
  }

  resetFeatureProperties(feature, properties) {
    feature.setProperties(properties);
  }

  getFeatureProperty(feature, propertyName) {
    const pros = feature.getProperties();
    return pros[propertyName];
  }

  getFeatureProperties(feature, fieldNames) {
    const p = {};
    const pro = feature.getProperties();
    for (let i = 0; i < fieldNames.length; i++) {
      p[fieldNames[i]] = pro[fieldNames[i]];
    }
    return p;
  }

  getFeatureId(feature) {
    return feature.getId();
  }

  setFeatureId(feature, id) {
    feature.setId(id);
  }

  getFeatureGeomType(feature) {
    const geom = feature.getGeometry();
    const type = geom.getType();
    return type;
  }

  getFeatureById(id) {
    let f = null;
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (!this.layerAssets[i].getSource()) { continue; }
      if (this.layerAssets[i].get('isCluster') ) {
        const src = this.layerAssets[i].getSource().getSource();
        f = src.getFeatureById(id);
      } else {
        f = this.layerAssets[i].getSource().getFeatureById(id);
      }
      
      if (f != null) { break; }
    }
    return f;
  }

  getFeatureByLayer(id, layerIndex) {
    if (layerIndex > this.layerAssets.length - 1) { return null; }
    let f = null;
    if (!this.layerAssets[layerIndex].getSource()) { return null; }
    f = this.layerAssets[layerIndex].getSource().getFeatureById(id);
    return f;
  }

  getFeatureByPixel(pixel) {
    return this.map.forEachFeatureAtPixel(pixel, function(feature, layer) {
      if (layer == null) {
        return null;
      } else {
        if (layer.get('isCluster')) {
          const fs = feature.get('features');
          if (fs && fs.length > 0) {
            return { feature: fs[0], layerIdx: layer.getZIndex()};
          } else {
            return { feature: null, layerIdx: layer.getZIndex()};
          }
        } else {
          return { feature, layerIdx: layer.getZIndex()};
        }
      }
    }, {
      hitTolerance: 10
    });
  }

  featureClone(fea, layerIndex) {
    const fClone = fea.clone();
    const pClone = fClone.getProperties();
    pClone.id = this.getFeatureId(fea);
    pClone.zIndex = layerIndex;
    fClone.setProperties(pClone);
    fClone.setId(pClone.id);
    return fClone;
  }

  getEventByPixel(pixel) {
    return this.map.getEventPixel(pixel);
  }

  getFeaturesCollection(options) {
    let fs = [];
    this.map.forEachFeatureAtPixel(options.pixel, (feature, layer) => {
      if (layer && !layer.get('isHeatMap') && layer.get('layerDisplayOnly') === false) { // 13521
        const layerIdx = layer.getZIndex();
        if (layerIdx && layerIdx < this.layerAssets.length) {
          if (this.layerAssets[layerIdx].get('isCluster')) {
            const lst = this.layerAssets[layerIdx].getSource().getSource().getFeatures();
            const p = feature.getProperties();
            const lstClicked = p.features;
            for (let i = 0; i < lstClicked.length; i++) {
              fs.push({feature: lstClicked[i], layerIdx: layerIdx });
              const fId = this.getFeatureId(lstClicked[i]);
              let id = fId;
              if (id.indexOf('_') > -1) { id = id.split('_')[0]; }
              for (let j = 0; j < lst.length; j++) {
                const jId = this.getFeatureId(lst[j]);
                if (jId === fId) { continue; }
                if (jId.indexOf(id) > -1) {
                  fs.push({ feature: lst[j], layerIdx: layerIdx });
                }
              }
            }
          } else if (this.layerAssets[layerIdx].getSource()) {
            const id = feature.getId();
            if (id) {
              fs.push({feature, layerIdx});
            }
            if (id && id.indexOf('_') > -1) {
              const id0 = id.split('_')[0];
  
              const lst = this.layerAssets[layerIdx].getSource().getFeatures();
              if (lst == null || lst.length === 0) { return fs; }
              lst.forEach((f, j) => {
                const fId = f.getId();
                if (fId && fId.indexOf(id0) > -1 && fId !== id ) {
                  fs.push({feature: f, layerIdx: layer.getZIndex()});
                }
              });
            }
          }
          

          if (typeof options.mode === 'undefined' || options.mode === null) {
            return fs;
          }
        }

      }
    }, {
      hitTolerance: 10
    });
    return fs;
  }

  getFeaturesCollectionId(id) {
    const fs = [];
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (!this.layerAssets[i].getSource()) { continue; }
      const lst = this.layerAssets[i].getSource().getFeatures();
      if (lst == null || lst.length === 0) { continue; }
      lst.forEach(function(f, j) {
        const fId = f.getId();
        if (fId && fId.indexOf(id) > -1) {
          // make sure this feature was not added in array
          let isExist = false;
          for (let k = 0; k < fs.length; k++) {
            if (fs[k].getId() === fId) {
              isExist = true;
              break;
            }
          }
          if (!isExist) { fs.push(f); }
        }
      });
    }
    return fs;
  }

  addFeature(feature, layerIndex) {
    if (feature == null) { return; }
    const p = feature.getProperties();
    p.zIndex = 0;
    if (layerIndex && layerIndex < this.layerAssets.length && this.layerAssets[layerIndex].getSource()) {
      p.zIndex = layerIndex;
      feature.setProperties(p);
      
      if (this.layerAssets[layerIndex].get('isCluster')) {
        const src = this.layerAssets[layerIndex].getSource().getSource();
        src.addFeature(feature);
      } else {
        if (this.type === 1) {
          feature.setStyle(this.styleAddress(feature, null));
        } else if (this.type === 3 && layerIndex !== this.layerIndexPrimary && layerIndex !== this.layerIndexSecondary) { // sc-selected-asset
            feature.setStyle(this.styleAsset(feature, layerIndex));
        }
        this.layerAssets[layerIndex].getSource().addFeature(feature);
      } 
    }
    feature.setProperties(p);
  }

  removeFeature(feature, layerIndex) {
    if (layerIndex) {
      if (layerIndex > this.layerAssets.length || !this.layerAssets[layerIndex].getSource()) { return; }
      this.layerAssets[layerIndex].getSource().removeFeature(feature);
    } else {
      const fId = feature.getId();
      this.removeItemFromMap(fId);
    }
  }

  removeItemFromMap(id) {
    for (let i = 0; i < this.layerAssets.length; i++) {
      if (!this.layerAssets[i].getSource()) { continue; }
      if (this.layerAssets[i].get('isCluster')) {
        const src = this.layerAssets[i].getSource().getSource();
        const f = src.getFeatureById(id);
        if (f) {
          src.removeFeature(f);
          break;
        }
      } else {
        const f = this.layerAssets[i].getSource().getFeatureById(id);
        if (f) {
          this.layerAssets[i].getSource().removeFeature(f);
          break;
        }
      }
      
      
    }
  }

  getMapSize() {
    return this.map.getSize();
  }

  getBoundingBox(options) {
    // get coordinate of view port
    if (this.view === null || typeof this.view === 'undefined') {
      return null;
    }
    const zoom = this.view.getZoom();
    const extent = this.view.calculateExtent(this.map.getSize());
    const bottomLeft = proj.transform(olExtent.getBottomLeft(extent), options.EPSG, sclMapConstant.EPSG_4326);
    const topRight = proj.transform(olExtent.getTopRight(extent), options.EPSG, sclMapConstant.EPSG_4326);

    const left = sclUtilMap.getWrapLon(bottomLeft[0]);
    if (isNaN(left)) { return null; }
    const bottom = bottomLeft[1];
    const right = sclUtilMap.getWrapLon(topRight[0]);
    if (isNaN(right)) { return null; }
    const top = topRight[1];

    return { left, top, right, bottom, zoom };
  }

  addSearchAddress(apiKey, wrapper, cb) {
    console.log('Need to bring back GoogleMapLoader ?');

    // GoogleMapsLoader.KEY = apiKey;
    // GoogleMapsLoader.LIBRARIES = 'places';
    // GoogleMapsLoader.SENSOR = true;
    // GoogleMapsLoader.load(function(google) {
    //     const autocomplete = new google.maps.places.Autocomplete(
    //         wrapper,
    //         { types: ['geocode'] });

    //     google.maps.event.addListener(autocomplete, 'place_changed', function() {
    //         const place = autocomplete.getPlace();
    //         const lat = place.geometry.location.lat();
    //         const lon = place.geometry.location.lng();

    //         if (cb && typeof cb == 'function') {
    //             cb(place, lat, lon);
    //         }
    //     });
    // });

  }

  clearAllFeatures() {
    // this.source.clear();//13835
    for (let i = 1; i < this.layerAssets.length; i++) { // start with layer index of asset from 1 to n
      this.layerAssets[i].getSource().clear(); // 13835
    }
  }

  clearAllFeaturesLayer(layerIndex) {
    if (layerIndex > this.layerAssets.length || !this.layerAssets[layerIndex].getSource()
     || this.layerAssets[layerIndex].get('isCluster')) { return; }
    this.layerAssets[layerIndex].getSource().clear();
  }

  updateSize() {
    this.map.updateSize();
  }

  getLatLngFromPixel(pixel) {
    const coordinate = this.map.getCoordinateFromPixel(pixel);
    const coor = proj.transform(coordinate, this.EPSG, 'EPSG:4326');
    return coor;
  }

  getPixelFromCoordinate(coordinate) {
    const coor = proj.transform(coordinate, this.EPSG, 'EPSG:4326');
    const pixel = this.map.getPixelFromCoordinate(coordinate);
    return {coor, pixel};
  }

  findFeatureByClick(evt, sType, assetSelectionsAvailable) {
    const features = [];
    const coordinate = evt.feature.getGeometry().getCoordinates();

    const obj = this.getPixelFromCoordinate(coordinate);

    const existedFeature = this.getFeaturesFromMap(features, obj.pixel, sType, assetSelectionsAvailable);

    return { coor: obj.coor, pixel: obj.pixel, features, existedFeature };
  }

  storeSelectedAssets(feature, isPrimary) {
    const fId = feature.getId();

    const fPro = feature.getProperties();
    const assetType = feature.get('assetType');


    if (this.selectedAssets == null) { this.selectedAssets = []; }
    const len = this.selectedAssets.length;
    for (let i = 0; i < len; i++) {
      const iId = this.selectedAssets[i].getId();

      if (iId === fId) {
        if (isPrimary) {
          const f = this.layerAssets[this.layerIndexPrimary].getSource().getFeatureById(iId);
          if (f == null) {
            this.addFeature(feature, this.layerIndexPrimary);
          }
        } else {
          const f = this.layerAssets[this.layerIndexSecondary].getSource().getFeatureById(iId);
          if (f == null) {
            this.addFeature(feature, this.layerIndexSecondary);
          }
        }

        return;
      }
    }
    this.selectedAssets.push(feature);

    // 13835
    if (isPrimary) {
      feature.set('zIndex', this.layerIndexPrimary);
      feature.setStyle(this.stylePrimaryAssetFunc(feature, null));
      this.layerAssets[this.layerIndexPrimary].getSource().addFeature(feature);
      this.layerAssets[this.layerIndexPrimary].setVisible(true);
    } else {
      feature.set('zIndex', this.layerIndexSecondary);
      feature.setStyle(this.styleSecondaryAssetFunc(feature, null));
      this.layerAssets[this.layerIndexSecondary].getSource().addFeature(feature);
      this.layerAssets[this.layerIndexSecondary].setVisible(true);
    }

    // this.source.addFeature(feature); // 13835
  }

  removeSelectedAssetsById(id) {
    let fId = id;
    let mode = 'NA';
    if (fId && fId.indexOf('primary') > -1) { mode = 'primary';
    } else if (fId && fId.indexOf('secondary') > -1) { mode = 'secondary'; }

    if (fId && fId.indexOf('_') > -1) { fId = fId.split('_')[0]; }
    const len = this.selectedAssets.length;
    for (let i = len - 1; i > -1; i--) {
      const iId = this.selectedAssets[i].getId();
      if ((iId && iId.indexOf(mode) > -1 && iId.indexOf(fId) > -1) || iId === fId ) {
        this.selectedAssets.splice(i, 1);
        this.removeItemFromMap(iId);
      }
    }

  }

  removeLayerFeatures() {
    // console.log('***********************open layer removeLayerFeatures***************************');
    // this.source.clear();//will re-write for mantis 13835
    this.clearAllFeatures(); // as same as this.clearAllFeatures() will remove removeLayerFeatures function

  }

  // copy from sclAssetLayers.removeUnselectedAsset
  removeUnselectedAsset(assets, unSelectedAssetIds, type) {
    for (let i = 0; i < unSelectedAssetIds.length; i++) {
      const priAsset = unSelectedAssetIds[i];
      for (let j = 0; j < assets.length; j++) {
        const id = assets[j].properties.linkAssets[0].documentId;
        if (id === priAsset) {
          this.removeItemFromMap(id + '_' + type);
          assets.splice(j, 1);
        }
      }
    }
  }

  updateLayers(pLayerAssets) {
    // remove feature in all layersz
    this.removeLayerFeatures();
    // remove old layers
    for (let i = 1; i < this.layerAssets.length; i++) {// start with layer index of asset from 1 to n
      this.map.removeLayer(this.layerAssets[i]);
    }

    // add new layers
    const obj = {layerAssets: pLayerAssets};
    this.createLayers(obj);
    if (this.layerAssets.length > 0) {
      for (let iLa = 1; iLa < this.layerAssets.length; iLa++) {// start with layer index of asset from 1 to n
        this.map.addLayer(this.layerAssets[iLa]);
      }
    }

  }

  // ************** use for psma layer reverse function *******************************************
  psmaStyleFunction(feature, resolution) {
    if (typeof feature !== 'object' || typeof feature.getProperties() === 'undefined') { return null; }
    const p = feature.getProperties();
    const description = feature.getProperties().description;
    const label = (typeof description === 'undefined' || description === null) ? '' : description + '';
    let image = new Circle({
      radius: 3,
      fill: new Fill({
        color: [255, 127, 39, 1]
      }),
      stroke: new Stroke({
        color: [255, 0, 0, 1],
        width: 1.5
      })
    });
    if (p.icon) {
      const anchor = [0.5, 0.5];
      image = new Icon(({
        src: p.icon,
        anchor
      }));
    }

    const style = new Style({
      fill: new Fill({
        color: 'rgba(255,255,255,0.4)'
      }),
      stroke: new Stroke({
        color: '#3399CC',
        width: 1.25
      }),
      text: new Text({
        font: '12px Arial',
        fill: new Fill({ color: '#000' }),
        stroke: new Stroke({
          color: '#fff', width: 2
        }),
        textBaseline: 'top',
        // get the text from the feature - `this` is ol.Feature
        // and show only under certain resolution
        text: label
      }),
      image,
      // zIndex: 10000 //13835
    });
    return style;
  }

  psmaCreateLayer(psmaPoints) {
    if (typeof this.psmaReverse === 'undefined' || this.psmaReverse === null) {
      this.psmaReverse = {};

      this.layerAssets[this.layerIndexAddress].getSource().addFeatures(psmaPoints); // 13835
      this.psmaReverse.psmaSourceVector = this.layerAssets[this.layerIndexAddress].getSource();

      this.layerAssets[this.layerIndexAddress].setStyle(this.psmaStyleFunction.bind(this)); // 13835
      this.psmaReverse.psmaLayer = this.layerAssets[this.layerIndexAddress]; // 13835

    }

    return this.psmaReverse;
  }

  psmaCreatePoint(coor, properties, psmaPoints) {
    const coorMap = proj.transform(coor, 'EPSG:4326', this.EPSG ); // 'EPSG:3111'
    const iconFeature = new Feature(new Point(coorMap));
    iconFeature.setProperties(properties);
    // this.psmaReverse.psmaSourceVector.addFeature(iconFeature);//13835
    this.layerAssets[this.layerIndexAddress].getSource().addFeature(iconFeature); // 13835

    psmaPoints.push(iconFeature);
    return psmaPoints;
  }

  psmaCreatePointClick(coor, radius, psmaPoints) {
    const circle4326 = circular(coor, radius); // openlayer 5
    const circle3857 = circle4326.clone().transform('EPSG:4326', this.EPSG); // 'EPSG:3111'
    const clickFeature = new Feature(circle3857);
    // this.psmaReverse.psmaSourceVector.addFeature(clickFeature);//13835
    this.layerAssets[this.layerIndexAddress].getSource().addFeature(clickFeature); // 13835

    psmaPoints.push(clickFeature);
    return psmaPoints;

  }

  psmaRemovePoint(psmaPoints, psmaSourceVector) {
    for (let i = 0; i < psmaPoints.length; ++i) {
      if (psmaPoints[i] == null) { continue; }
      psmaSourceVector.removeFeature(psmaPoints[i]);
    }

    return { psmaPoints, psmaSourceVector };
  }

  psmaDistanceCoords(coorA, coorB) {
    const distance = getDistance(coorA, coorB); // openlayer 5
    return distance;
  }

  // copy from sclUtilMap.positionView
  positionView(lat, lon, zoom, EPSG) {
    // if(this.wmsState.finishLoad == false || this.wmsState.tileCount == 0){
    //     this.positionObject = { hasCall: true, lat: lat, lon: lon, zoom: zoom, epsg: EPSG };
    //     return;
    // }

    lat = (typeof lat !== 'undefined') ? lat : 0;
    lon = (typeof lon !== 'undefined') ? lon : 0;
    zoom = (typeof zoom !== 'undefined') ? zoom : 2;
    EPSG = (typeof EPSG !== 'undefined') ? EPSG : 'EPSG:3857';
    this.view.setCenter(proj.transform([lon, lat], 'EPSG:4326', EPSG));
    this.view.setZoom(zoom);
  }

  //
  setCenterMapViewByCoordinates(bbox) {
    // new bounding box
    const bottom = bbox[1][1]; const left = bbox[0][0]; const top = bbox[0][1]; const right = bbox[1][0];
    let ext = [left, bottom, right, top]; // [minlon, minlat, maxlon, maxlat];
    ext = olExtent.applyTransform(ext, proj.getTransform('EPSG:4326', this.EPSG));


    this.view.fit(ext,
      {   size: this.map.getSize()
        , constrainResolution: false
      });

  }
  // 15262
  setCenter(lat, lon) {
    const center = proj.transform([lon, lat], 'EPSG:4326', this.EPSG);
    this.view.setCenter(center);
  }
  setSelectAssetCluster (features, currentSelected) {
    for (let i = 0; i < features.length; i++) {
      currentSelected.push(features[i].feature);
    }
  }

  extendToCoordinate(coord) {
    const currentLoc = proj.transform(this.map.getView().getCenter(), this.EPSG, 'EPSG:4326');
    let ext = boundingExtent([coord, currentLoc]);
    ext = proj.transformExtent(ext, proj.get('EPSG:4326'), proj.get(this.EPSG));
    this.map.getView().fit(ext, {
      size: this.map.getSize(),
      padding: [50, 0, 50, 0]
    });
  }
}
